// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css */
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/* ! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com *//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.prose {
  color: var(--tw-prose-body);
  max-width: 65ch;
}
.prose :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-lead);
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}
.prose :where(a):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-links);
  text-decoration: underline;
  font-weight: 500;
}
.prose :where(strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-bold);
  font-weight: 600;
}
.prose :where(a strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol[type="A"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="A" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-alpha;
}
.prose :where(ol[type="a" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-alpha;
}
.prose :where(ol[type="I"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="I" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: upper-roman;
}
.prose :where(ol[type="i" s]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: lower-roman;
}
.prose :where(ol[type="1"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: decimal;
}
.prose :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  list-style-type: disc;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
  padding-inline-start: 1.625em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  font-weight: 400;
  color: var(--tw-prose-counters);
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *))::marker {
  color: var(--tw-prose-bullets);
}
.prose :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.25em;
}
.prose :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-color: var(--tw-prose-hr);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.prose :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-style: italic;
  color: var(--tw-prose-quotes);
  border-inline-start-width: 0.25rem;
  border-inline-start-color: var(--tw-prose-quote-borders);
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-inline-start: 1em;
}
.prose :where(blockquote p:first-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: open-quote;
}
.prose :where(blockquote p:last-of-type):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: close-quote;
}
.prose :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.prose :where(h1 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 900;
  color: inherit;
}
.prose :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.prose :where(h2 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 800;
  color: inherit;
}
.prose :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.prose :where(h3 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.prose :where(h4 strong):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 700;
  color: inherit;
}
.prose :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  display: block;
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-weight: 500;
  font-family: inherit;
  color: var(--tw-prose-kbd);
  box-shadow: 0 0 0 1px var(--tw-prose-kbd-shadows), 0 3px 0 var(--tw-prose-kbd-shadows);
  font-size: 0.875em;
  border-radius: 0.3125rem;
  padding-top: 0.1875em;
  padding-inline-end: 0.375em;
  padding-bottom: 0.1875em;
  padding-inline-start: 0.375em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-code);
  font-weight: 600;
  font-size: 0.875em;
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: "\`";
}
.prose :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: "\`";
}
.prose :where(a code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h1 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.875em;
}
.prose :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
  font-size: 0.9em;
}
.prose :where(h4 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(blockquote code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(thead th code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: inherit;
}
.prose :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-pre-code);
  background-color: var(--tw-prose-pre-bg);
  overflow-x: auto;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-inline-end: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-inline-start: 1.1428571em;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::before {
  content: none;
}
.prose :where(pre code):not(:where([class~="not-prose"],[class~="not-prose"] *))::after {
  content: none;
}
.prose :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  width: 100%;
  table-layout: auto;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.prose :where(thead):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-th-borders);
}
.prose :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-headings);
  font-weight: 600;
  vertical-align: bottom;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody tr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 1px;
  border-bottom-color: var(--tw-prose-td-borders);
}
.prose :where(tbody tr:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-bottom-width: 0;
}
.prose :where(tbody td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: baseline;
}
.prose :where(tfoot):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  border-top-width: 1px;
  border-top-color: var(--tw-prose-th-borders);
}
.prose :where(tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  vertical-align: top;
}
.prose :where(th, td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  text-align: start;
}
.prose :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  color: var(--tw-prose-captions);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.prose {
  --tw-prose-body: oklch(37.3% 0.034 259.733);
  --tw-prose-headings: oklch(21% 0.034 264.665);
  --tw-prose-lead: oklch(44.6% 0.03 256.802);
  --tw-prose-links: oklch(21% 0.034 264.665);
  --tw-prose-bold: oklch(21% 0.034 264.665);
  --tw-prose-counters: oklch(55.1% 0.027 264.364);
  --tw-prose-bullets: oklch(87.2% 0.01 258.338);
  --tw-prose-hr: oklch(92.8% 0.006 264.531);
  --tw-prose-quotes: oklch(21% 0.034 264.665);
  --tw-prose-quote-borders: oklch(92.8% 0.006 264.531);
  --tw-prose-captions: oklch(55.1% 0.027 264.364);
  --tw-prose-kbd: oklch(21% 0.034 264.665);
  --tw-prose-kbd-shadows: color-mix(in oklab, oklch(21% 0.034 264.665) 10%, transparent);
  --tw-prose-code: oklch(21% 0.034 264.665);
  --tw-prose-pre-code: oklch(92.8% 0.006 264.531);
  --tw-prose-pre-bg: oklch(27.8% 0.033 256.848);
  --tw-prose-th-borders: oklch(87.2% 0.01 258.338);
  --tw-prose-td-borders: oklch(92.8% 0.006 264.531);
  --tw-prose-invert-body: oklch(87.2% 0.01 258.338);
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: oklch(70.7% 0.022 261.325);
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: oklch(70.7% 0.022 261.325);
  --tw-prose-invert-bullets: oklch(44.6% 0.03 256.802);
  --tw-prose-invert-hr: oklch(37.3% 0.034 259.733);
  --tw-prose-invert-quotes: oklch(96.7% 0.003 264.542);
  --tw-prose-invert-quote-borders: oklch(37.3% 0.034 259.733);
  --tw-prose-invert-captions: oklch(70.7% 0.022 261.325);
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: rgb(255 255 255 / 10%);
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: oklch(87.2% 0.01 258.338);
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: oklch(44.6% 0.03 256.802);
  --tw-prose-invert-td-borders: oklch(37.3% 0.034 259.733);
  font-size: 1rem;
  line-height: 1.75;
}
.prose :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.prose :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.375em;
}
.prose :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.375em;
}
.prose :where(.prose > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(.prose > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(.prose > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
}
.prose :where(.prose > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.25em;
}
.prose :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.prose :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.prose :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5em;
  padding-inline-start: 1.625em;
}
.prose :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.5714286em;
  padding-inline-end: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-inline-start: 0.5714286em;
}
.prose :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2em;
  margin-bottom: 2em;
}
.prose :where(.prose > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose :where(.prose > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-sm {
  font-size: 0.875rem;
  line-height: 1.7142857;
}
.prose-sm :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2857143em;
  line-height: 1.5555556;
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-sm :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.1111111em;
}
.prose-sm :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 2.1428571em;
  margin-top: 0;
  margin-bottom: 0.8em;
  line-height: 1.2;
}
.prose-sm :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.4285714em;
  margin-top: 1.6em;
  margin-bottom: 0.8em;
  line-height: 1.4;
}
.prose-sm :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2857143em;
  margin-top: 1.5555556em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-sm :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.4285714em;
  margin-bottom: 0.5714286em;
  line-height: 1.4285714;
}
.prose-sm :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  border-radius: 0.3125rem;
  padding-top: 0.1428571em;
  padding-inline-end: 0.3571429em;
  padding-bottom: 0.1428571em;
  padding-inline-start: 0.3571429em;
}
.prose-sm :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
}
.prose-sm :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.9em;
}
.prose-sm :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
}
.prose-sm :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.6666667;
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  border-radius: 0.25rem;
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.2857143em;
  margin-bottom: 0.2857143em;
}
.prose-sm :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4285714em;
}
.prose-sm :where(.prose-sm > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(.prose-sm > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(.prose-sm > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.1428571em;
}
.prose-sm :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}
.prose-sm :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}
.prose-sm :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.1428571em;
}
.prose-sm :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.2857143em;
  padding-inline-start: 1.5714286em;
}
.prose-sm :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 2.8571429em;
  margin-bottom: 2.8571429em;
}
.prose-sm :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.5;
}
.prose-sm :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-sm :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-sm :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.6666667em;
  padding-inline-end: 1em;
  padding-bottom: 0.6666667em;
  padding-inline-start: 1em;
}
.prose-sm :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-sm :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-sm :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}
.prose-sm :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-sm :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8571429em;
  line-height: 1.3333333;
  margin-top: 0.6666667em;
}
.prose-sm :where(.prose-sm > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-sm :where(.prose-sm > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-lg {
  font-size: 1.125rem;
  line-height: 1.7777778;
}
.prose-lg :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.2222222em;
  line-height: 1.4545455;
  margin-top: 1.0909091em;
  margin-bottom: 1.0909091em;
}
.prose-lg :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  padding-inline-start: 1em;
}
.prose-lg :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.8333333em;
  line-height: 1;
}
.prose-lg :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.6666667em;
  margin-top: 1.8666667em;
  margin-bottom: 1.0666667em;
  line-height: 1.3333333;
}
.prose-lg :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 1.3333333em;
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}
.prose-lg :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}
.prose-lg :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  border-radius: 0.3125rem;
  padding-top: 0.2222222em;
  padding-inline-end: 0.4444444em;
  padding-bottom: 0.2222222em;
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
}
.prose-lg :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8666667em;
}
.prose-lg :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.875em;
}
.prose-lg :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.75;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.375rem;
  padding-top: 1em;
  padding-inline-end: 1.5em;
  padding-bottom: 1em;
  padding-inline-start: 1.5em;
}
.prose-lg :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}
.prose-lg :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0.4444444em;
}
.prose-lg :where(.prose-lg > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg :where(.prose-lg > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(.prose-lg > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.3333333em;
}
.prose-lg :where(.prose-lg > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(.prose-lg > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 1.3333333em;
}
.prose-lg :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}
.prose-lg :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}
.prose-lg :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.3333333em;
}
.prose-lg :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0.6666667em;
  padding-inline-start: 1.5555556em;
}
.prose-lg :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 3.1111111em;
  margin-bottom: 3.1111111em;
}
.prose-lg :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.5;
}
.prose-lg :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0.75em;
  padding-bottom: 0.75em;
  padding-inline-start: 0.75em;
}
.prose-lg :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-lg :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-lg :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-top: 0.75em;
  padding-inline-end: 0.75em;
  padding-bottom: 0.75em;
  padding-inline-start: 0.75em;
}
.prose-lg :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-start: 0;
}
.prose-lg :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  padding-inline-end: 0;
}
.prose-lg :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}
.prose-lg :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
  margin-bottom: 0;
}
.prose-lg :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  font-size: 0.8888889em;
  line-height: 1.5;
  margin-top: 1em;
}
.prose-lg :where(.prose-lg > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-top: 0;
}
.prose-lg :where(.prose-lg > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
  margin-bottom: 0;
}
.prose-slate {
  --tw-prose-body: oklch(37.2% 0.044 257.287);
  --tw-prose-headings: oklch(20.8% 0.042 265.755);
  --tw-prose-lead: oklch(44.6% 0.043 257.281);
  --tw-prose-links: oklch(20.8% 0.042 265.755);
  --tw-prose-bold: oklch(20.8% 0.042 265.755);
  --tw-prose-counters: oklch(55.4% 0.046 257.417);
  --tw-prose-bullets: oklch(86.9% 0.022 252.894);
  --tw-prose-hr: oklch(92.9% 0.013 255.508);
  --tw-prose-quotes: oklch(20.8% 0.042 265.755);
  --tw-prose-quote-borders: oklch(92.9% 0.013 255.508);
  --tw-prose-captions: oklch(55.4% 0.046 257.417);
  --tw-prose-kbd: oklch(20.8% 0.042 265.755);
  --tw-prose-kbd-shadows: color-mix(in oklab, oklch(20.8% 0.042 265.755) 10%, transparent);
  --tw-prose-code: oklch(20.8% 0.042 265.755);
  --tw-prose-pre-code: oklch(92.9% 0.013 255.508);
  --tw-prose-pre-bg: oklch(27.9% 0.041 260.031);
  --tw-prose-th-borders: oklch(86.9% 0.022 252.894);
  --tw-prose-td-borders: oklch(92.9% 0.013 255.508);
  --tw-prose-invert-body: oklch(86.9% 0.022 252.894);
  --tw-prose-invert-headings: #fff;
  --tw-prose-invert-lead: oklch(70.4% 0.04 256.788);
  --tw-prose-invert-links: #fff;
  --tw-prose-invert-bold: #fff;
  --tw-prose-invert-counters: oklch(70.4% 0.04 256.788);
  --tw-prose-invert-bullets: oklch(44.6% 0.043 257.281);
  --tw-prose-invert-hr: oklch(37.2% 0.044 257.287);
  --tw-prose-invert-quotes: oklch(96.8% 0.007 247.896);
  --tw-prose-invert-quote-borders: oklch(37.2% 0.044 257.287);
  --tw-prose-invert-captions: oklch(70.4% 0.04 256.788);
  --tw-prose-invert-kbd: #fff;
  --tw-prose-invert-kbd-shadows: rgb(255 255 255 / 10%);
  --tw-prose-invert-code: #fff;
  --tw-prose-invert-pre-code: oklch(86.9% 0.022 252.894);
  --tw-prose-invert-pre-bg: rgb(0 0 0 / 50%);
  --tw-prose-invert-th-borders: oklch(44.6% 0.043 257.281);
  --tw-prose-invert-td-borders: oklch(37.2% 0.044 257.287);
}
.prose-red {
  --tw-prose-links: oklch(57.7% 0.245 27.325);
  --tw-prose-invert-links: oklch(63.7% 0.237 25.331);
}
.prose-indigo {
  --tw-prose-links: oklch(51.1% 0.262 276.966);
  --tw-prose-invert-links: oklch(58.5% 0.233 277.117);
}
.prose-invert {
  --tw-prose-body: var(--tw-prose-invert-body);
  --tw-prose-headings: var(--tw-prose-invert-headings);
  --tw-prose-lead: var(--tw-prose-invert-lead);
  --tw-prose-links: var(--tw-prose-invert-links);
  --tw-prose-bold: var(--tw-prose-invert-bold);
  --tw-prose-counters: var(--tw-prose-invert-counters);
  --tw-prose-bullets: var(--tw-prose-invert-bullets);
  --tw-prose-hr: var(--tw-prose-invert-hr);
  --tw-prose-quotes: var(--tw-prose-invert-quotes);
  --tw-prose-quote-borders: var(--tw-prose-invert-quote-borders);
  --tw-prose-captions: var(--tw-prose-invert-captions);
  --tw-prose-kbd: var(--tw-prose-invert-kbd);
  --tw-prose-kbd-shadows: var(--tw-prose-invert-kbd-shadows);
  --tw-prose-code: var(--tw-prose-invert-code);
  --tw-prose-pre-code: var(--tw-prose-invert-pre-code);
  --tw-prose-pre-bg: var(--tw-prose-invert-pre-bg);
  --tw-prose-th-borders: var(--tw-prose-invert-th-borders);
  --tw-prose-td-borders: var(--tw-prose-invert-td-borders);
}

  /* --- 1. TYPOGRAPHY --- */
  .heading-section {
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 3.25rem;
  color: oklch(20.8% 0.042 265.755);
}
  .heading-section:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .subheading-card {
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 2rem;
  color: oklch(20.8% 0.042 265.755);
}

  .subheading-card:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .text-body-muted {
  color: oklch(55.4% 0.046 257.417);
}

  .text-body-muted:is(.dark *) {
  color: oklch(70.4% 0.04 256.788);
}

  /* --- 2. BUTTONS --- */
  .btn-pill-outline {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: 13rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 1px;
  border-color: oklch(86.9% 0.022 252.894);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  font-weight: 600;
  color: oklch(20.8% 0.042 265.755);
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
  .btn-pill-outline:hover {
  background-color: oklch(96.8% 0.007 247.896);
}
  .btn-pill-outline:is(.dark *) {
  border-color: oklch(37.2% 0.044 257.287);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
  .btn-pill-outline:hover:is(.dark *) {
  background-color: oklch(27.9% 0.041 260.031);
}
  @media (min-width: 1024px) {
  .btn-pill-outline {
    margin-left: 0px;
    margin-right: 0px;
  }
}

  .btn-swiper {
  display: flex;
  height: 2.75rem;
  width: 2.75rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(0 36 91 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(0 36 91 / var(--tw-text-opacity, 1));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
}

  .btn-swiper:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 91 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  .link-action {
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(0 27 68 / var(--tw-text-opacity, 1));
}

  .link-action:hover {
  --tw-text-opacity: 1;
  color: rgb(0 9 23 / var(--tw-text-opacity, 1));
}

  .link-action:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(121 153 191 / var(--tw-text-opacity, 1));
}

  .link-action:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(154 179 208 / var(--tw-text-opacity, 1));
}

  /* --- 3. CARDS & LAYOUT --- */
  .section-bg {
  background-color: oklch(98.4% 0.003 247.858);
  padding-top: 6rem;
  padding-bottom: 6rem;
}
  .section-bg:is(.dark *) {
  background-color: oklch(20.8% 0.042 265.755);
}

  .card-image-wrapper {
  margin-bottom: 1.5rem;
  display: flex;
  height: 16rem;
  width: 100%;
  align-items: center;
  overflow: hidden;
  border-radius: 1rem;
  background-color: oklch(92.9% 0.013 255.508);
}

  .card-image-wrapper:is(.dark *) {
  background-color: oklch(27.9% 0.041 260.031);
}

  .card-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 500ms;
}

  .group:hover .card-image {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .grid-cols-24 {
    grid-template-columns: repeat(24, minmax(0, 1fr));
  }

  /* =========================================
     TIPTAP EDITOR STYLES (Internal)
     ========================================= */

  .prose-custom {
    max-width: none !important;
    width: 100% !important;
    font-size: 1rem;
    line-height: 1.5rem;
    line-height: 1.625;
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1));
  }

  .ProseMirror {
    min-height: 400px;
    padding-bottom: 50px;
    outline: none !important;
  }

  /* Headings & Text */
  .prose-custom h1 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 800;
  line-height: 1.25;
  color: oklch(20.8% 0.042 265.755);
}
  .prose-custom h2 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  line-height: 1.25;
  color: oklch(27.9% 0.041 260.031);
}
  .prose-custom h3 {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
  color: oklch(27.9% 0.041 260.031);
}
  .prose-custom h4 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
  color: oklch(27.9% 0.041 260.031);
}
  .prose-custom p {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  line-height: 1.75rem;
}

  /* Fancy Blockquotes */
  .prose-custom blockquote {
    position: relative;
    border-left: 4px solid #2563eb;
    background-color: #eff6ff;
    color: #334155;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    display: block;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-right: 1rem;
    padding-left: 3.5rem;
    font-style: italic;
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    quotes: none;
  }

  .dark .prose-custom blockquote {
    background-color: #1e293b;
    color: #e2e8e0;
    border-left-color: #3b82f6;
  }

  .prose-custom blockquote::before {
    content: "“";
    position: absolute;
    top: -0.25rem;
    left: 0.5rem;
    font-size: 5rem;
    line-height: 1;
    font-family: Georgia, serif;
    color: #93c5fd;
    opacity: 0.5;
    pointer-events: none;
  }

  /* AI Sections Highlight */
  .prose-custom section {
  position: relative;
  border-radius: 0.75rem;
  border-width: 1px;
  border-color: transparent;
  padding: 1.5rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

  .prose-custom section.ProseMirror-selectednode {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
  background-color: rgb(238 242 255 / 0.3);
}

  /* Lists & Links */
  .prose-custom ul {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  list-style-type: disc;
}
  .prose-custom ul > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
  .prose-custom ul {
  padding-left: 1.5rem;
}
  .prose-custom ol {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  list-style-type: decimal;
}
  .prose-custom ol > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
  .prose-custom ol {
  padding-left: 1.5rem;
}
  .prose-custom pre {
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow-x: auto;
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: oklch(37.2% 0.044 257.287);
  background-color: oklch(20.8% 0.042 265.755);
  padding: 1rem;
  color: oklch(98.4% 0.003 247.858);
}
  .prose-custom code {
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: oklch(92.9% 0.013 255.508);
  background-color: oklch(96.8% 0.007 247.896);
  padding-left: 0.375rem;
  padding-right: 0.375rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-family: JetBrains Mono, monospace;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
  .prose-custom a {
  cursor: pointer;
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
  text-decoration-line: underline;
  text-decoration-color: #93c5fd;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
  .prose-custom a:hover {
  text-decoration-color: #2563eb;
}

  /* --- TABLES --- */
  .prose-custom table {
    border-collapse: collapse;
    margin: 2rem 0;
    overflow: hidden;
    table-layout: fixed;
    width: 100%;
  }

  .prose-custom td, .prose-custom th {
    border: 1px solid #cbd5e1 !important;
    box-sizing: border-box;
    min-width: 1em;
    padding: 8px 10px;
    position: relative;
    vertical-align: top;
  }

  .dark .prose-custom td, .dark .prose-custom th { border-color: #475569 !important; }

  .prose-custom th {
    background-color: #f1f5f9 !important;
    font-weight: bold;
    text-align: left;
  }

  .dark .prose-custom th { background-color: #1e293b !important; color: #fff; }

  /* Table Resize Handles */
  .column-resize-handle {
  pointer-events: none;
  position: absolute;
  right: -2px;
  bottom: -2px;
  top: 0px;
  z-index: 20;
  width: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

  .prose-custom th:hover .column-resize-handle,
  .prose-custom td:hover .column-resize-handle {
  pointer-events: auto;
  opacity: 1;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-inset-0\\.5 {
  inset: -0.125rem;
}
.-inset-1 {
  inset: -0.25rem;
}
.-inset-12 {
  inset: -3rem;
}
.-inset-2 {
  inset: -0.5rem;
}
.-inset-4 {
  inset: -1rem;
}
.-inset-8 {
  inset: -2rem;
}
.-inset-px {
  inset: -1px;
}
.inset-0 {
  inset: 0px;
}
.inset-20 {
  inset: 5rem;
}
.inset-6 {
  inset: 1.5rem;
}
.inset-x-4 {
  left: 1rem;
  right: 1rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-1\\.5 {
  bottom: -0.375rem;
}
.-bottom-10 {
  bottom: -2.5rem;
}
.-bottom-12 {
  bottom: -3rem;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-bottom-2\\.5 {
  bottom: -0.625rem;
}
.-bottom-3 {
  bottom: -0.75rem;
}
.-bottom-4 {
  bottom: -1rem;
}
.-bottom-8 {
  bottom: -2rem;
}
.-bottom-\\[20\\%\\] {
  bottom: -20%;
}
.-left-1 {
  left: -0.25rem;
}
.-left-1\\.5 {
  left: -0.375rem;
}
.-left-1\\/2 {
  left: -50%;
}
.-left-10 {
  left: -2.5rem;
}
.-left-2 {
  left: -0.5rem;
}
.-left-2\\.5 {
  left: -0.625rem;
}
.-left-3 {
  left: -0.75rem;
}
.-left-\\[10\\%\\] {
  left: -10%;
}
.-left-\\[38px\\] {
  left: -38px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-1\\.5 {
  right: -0.375rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-2\\.5 {
  right: -0.625rem;
}
.-right-20 {
  right: -5rem;
}
.-right-3 {
  right: -0.75rem;
}
.-right-4 {
  right: -1rem;
}
.-right-40 {
  right: -10rem;
}
.-right-\\[10\\%\\] {
  right: -10%;
}
.-right-\\[500px\\] {
  right: -500px;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-1\\/2 {
  top: -50%;
}
.-top-10 {
  top: -2.5rem;
}
.-top-12 {
  top: -3rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-20 {
  top: -5rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-32 {
  top: -8rem;
}
.-top-4 {
  top: -1rem;
}
.-top-40 {
  top: -10rem;
}
.-top-5 {
  top: -1.25rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-8 {
  top: -2rem;
}
.-top-\\[20\\%\\] {
  top: -20%;
}
.-top-\\[500px\\] {
  top: -500px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-1\\/4 {
  bottom: 25%;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-12 {
  bottom: 3rem;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-2\\.5 {
  bottom: 0.625rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-\\[-10\\%\\] {
  bottom: -10%;
}
.bottom-\\[10\\%\\] {
  bottom: 10%;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/4 {
  left: 25%;
}
.left-10 {
  left: 2.5rem;
}
.left-12 {
  left: 3rem;
}
.left-14 {
  left: 3.5rem;
}
.left-16 {
  left: 4rem;
}
.left-2 {
  left: 0.5rem;
}
.left-20 {
  left: 5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-64 {
  left: 16rem;
}
.left-8 {
  left: 2rem;
}
.left-\\[-10\\%\\] {
  left: -10%;
}
.left-\\[-2px\\] {
  left: -2px;
}
.left-\\[-60px\\] {
  left: -60px;
}
.left-\\[10\\%\\] {
  left: 10%;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-1\\/2 {
  right: 50%;
}
.right-1\\/4 {
  right: 25%;
}
.right-10 {
  right: 2.5rem;
}
.right-12 {
  right: 3rem;
}
.right-16 {
  right: 4rem;
}
.right-2 {
  right: 0.5rem;
}
.right-20 {
  right: 5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-8 {
  right: 2rem;
}
.right-\\[-10\\%\\] {
  right: -10%;
}
.right-\\[-60px\\] {
  right: -60px;
}
.start-0 {
  inset-inline-start: 0px;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/4 {
  top: 25%;
}
.top-10 {
  top: 2.5rem;
}
.top-12 {
  top: 3rem;
}
.top-16 {
  top: 4rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-20 {
  top: 5rem;
}
.top-24 {
  top: 6rem;
}
.top-28 {
  top: 7rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-32 {
  top: 8rem;
}
.top-4 {
  top: 1rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[-10\\%\\] {
  top: -10%;
}
.top-\\[10\\%\\] {
  top: 10%;
}
.top-\\[26px\\] {
  top: 26px;
}
.top-full {
  top: 100%;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[-1\\] {
  z-index: -1;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[150\\] {
  z-index: 150;
}
.z-\\[200\\] {
  z-index: 200;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[90\\] {
  z-index: 90;
}
.z-\\[9998\\] {
  z-index: 9998;
}
.z-\\[99998\\] {
  z-index: 99998;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-9 {
  grid-column: span 9 / span 9;
}
.col-span-full {
  grid-column: 1 / -1;
}
.row-span-1 {
  grid-row: span 1 / span 1;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.clear-left {
  clear: left;
}
.clear-right {
  clear: right;
}
.clear-both {
  clear: both;
}
.\\!m-0 {
  margin: 0px !important;
}
.-m-1 {
  margin: -0.25rem;
}
.-m-2 {
  margin: -0.5rem;
}
.-m-4 {
  margin: -1rem;
}
.m-0 {
  margin: 0px;
}
.m-4 {
  margin: 1rem;
}
.m-6 {
  margin: 1.5rem;
}
.m-auto {
  margin: auto;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.-my-2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-10 {
  margin-bottom: -2.5rem;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-mb-5 {
  margin-bottom: -1.25rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-me-2 {
  margin-inline-end: -0.5rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-mr-16 {
  margin-right: -4rem;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.-mt-10 {
  margin-top: -2.5rem;
}
.-mt-16 {
  margin-top: -4rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-32 {
  margin-bottom: 8rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-16 {
  margin-left: 4rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-9 {
  margin-left: 2.25rem;
}
.ml-\\[-10\\%\\] {
  margin-left: -10%;
}
.ml-\\[25\\%\\] {
  margin-left: 25%;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-10 {
  margin-right: 2.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-40 {
  margin-top: 10rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-10px\\] {
  margin-top: -10px;
}
.mt-\\[-4px\\] {
  margin-top: -4px;
}
.mt-\\[350px\\] {
  margin-top: 350px;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-6 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.\\!grid {
  display: grid !important;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[1\\.91\\/1\\] {
  aspect-ratio: 1.91/1;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-\\[3\\/4\\] {
  aspect-ratio: 3/4;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-60 {
  height: 15rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[1000px\\] {
  height: 1000px;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[150\\%\\] {
  height: 150%;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[200\\%\\] {
  height: 200%;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[40\\%\\] {
  height: 40%;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[45\\%\\] {
  height: 45%;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[50\\%\\] {
  height: 50%;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[55\\%\\] {
  height: 55%;
}
.h-\\[550px\\] {
  height: 550px;
}
.h-\\[60\\%\\] {
  height: 60%;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[650px\\] {
  height: 650px;
}
.h-\\[700px\\] {
  height: 700px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[800px\\] {
  height: 800px;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[85\\%\\] {
  height: 85%;
}
.h-\\[85vh\\] {
  height: 85vh;
}
.h-\\[900px\\] {
  height: 900px;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[calc\\(100vh-60px\\)\\] {
  height: calc(100vh - 60px);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-20 {
  max-height: 5rem;
}
.max-h-32 {
  max-height: 8rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[600px\\] {
  max-height: 600px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[650px\\] {
  max-height: 650px;
}
.max-h-\\[65vh\\] {
  max-height: 65vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[1000px\\] {
  min-height: 1000px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[1100px\\] {
  min-height: 1100px;
}
.min-h-\\[11in\\] {
  min-height: 11in;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.min-h-\\[16rem\\] {
  min-height: 16rem;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[250px\\] {
  min-height: 250px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[350px\\] {
  min-height: 350px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[420px\\] {
  min-height: 420px;
}
.min-h-\\[450px\\] {
  min-height: 450px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[50vh\\] {
  min-height: 50vh;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[80vh\\] {
  min-height: 80vh;
}
.min-h-\\[900px\\] {
  min-height: 900px;
}
.min-h-\\[calc\\(100vh-300px\\)\\] {
  min-height: calc(100vh - 300px);
}
.min-h-fit {
  min-height: fit-content;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-1\\/6 {
  width: 16.666667%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[1000px\\] {
  width: 1000px;
}
.w-\\[150\\%\\] {
  width: 150%;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[200\\%\\] {
  width: 200%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[3px\\] {
  width: 3px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[45\\%\\] {
  width: 45%;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[550px\\] {
  width: 550px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[68px\\] {
  width: 68px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[75\\%\\] {
  width: 75%;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[900px\\] {
  width: 900px;
}
.w-\\[90vw\\] {
  width: 90vw;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[350px\\] {
  min-width: 350px;
}
.min-w-\\[360px\\] {
  min-width: 360px;
}
.min-w-\\[400px\\] {
  min-width: 400px;
}
.min-w-\\[600px\\] {
  min-width: 600px;
}
.min-w-\\[700px\\] {
  min-width: 700px;
}
.min-w-fit {
  min-width: fit-content;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[110px\\] {
  max-width: 110px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[1920px\\] {
  max-width: 1920px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[60px\\] {
  max-width: 60px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[700px\\] {
  max-width: 700px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[80px\\] {
  max-width: 80px;
}
.max-w-\\[816px\\] {
  max-width: 816px;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[850px\\] {
  max-width: 850px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[900px\\] {
  max-width: 900px;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[950px\\] {
  max-width: 950px;
}
.max-w-\\[95vw\\] {
  max-width: 95vw;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-center {
  transform-origin: center;
}
.origin-left {
  transform-origin: left;
}
.origin-top-left {
  transform-origin: top left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2 {
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2 {
  --tw-translate-x: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-56 {
  --tw-translate-x: 14rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-10px\\] {
  --tw-translate-x: -10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-1 {
  --tw-rotate: -1deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-2 {
  --tw-rotate: -2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-3 {
  --tw-rotate: -3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-6 {
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-1 {
  --tw-rotate: 1deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-2 {
  --tw-rotate: 2deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-3 {
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-6 {
  --tw-rotate: 6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-skew-x-12 {
  --tw-skew-x: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150 {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[1\\.02\\] {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-\\[spin_60s_linear_infinite\\] {
  animation: spin 60s linear infinite;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-default {
  cursor: default;
}
.cursor-ew-resize {
  cursor: ew-resize;
}
.cursor-grab {
  cursor: grab;
}
.cursor-help {
  cursor: help;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-ns-resize {
  cursor: ns-resize;
}
.cursor-nwse-resize {
  cursor: nwse-resize;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-se-resize {
  cursor: se-resize;
}
.cursor-text {
  cursor: text;
}
.cursor-wait {
  cursor: wait;
}
.cursor-zoom-in {
  cursor: zoom-in;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.auto-rows-\\[minmax\\(240px\\2c auto\\)\\] {
  grid-auto-rows: minmax(240px,auto);
}
.auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-\\[repeat\\(24\\2c minmax\\(0\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(24,minmax(0,1fr));
}
.grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
.grid-rows-\\[auto_auto_1fr\\] {
  grid-template-rows: auto auto 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[1px\\] {
  gap: 1px;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-1\\.5 {
  column-gap: 0.375rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-3\\.5 {
  column-gap: 0.875rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-16 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]) {
  border-color: oklch(96.8% 0.007 247.896);
}
.divide-slate-50 > :not([hidden]) ~ :not([hidden]) {
  border-color: oklch(98.4% 0.003 247.858);
}
.divide-slate-700 > :not([hidden]) ~ :not([hidden]) {
  border-color: oklch(37.2% 0.044 257.287);
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-\\[2\\.5rem\\] {
  border-radius: 2.5rem;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[2rem\\] {
  border-radius: 2rem;
}
.rounded-\\[32px\\] {
  border-radius: 32px;
}
.rounded-\\[3rem\\] {
  border-radius: 3rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-sm {
  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-xl {
  border-bottom-left-radius: 0.75rem;
}
.rounded-tr-sm {
  border-top-right-radius: 0.125rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-8 {
  border-width: 8px;
}
.border-\\[12px\\] {
  border-width: 12px;
}
.border-\\[16px\\] {
  border-width: 16px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-\\[4px\\] {
  border-width: 4px;
}
.border-\\[6px\\] {
  border-width: 6px;
}
.border-\\[8px\\] {
  border-width: 8px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-2 {
  border-top-width: 2px;
  border-bottom-width: 2px;
}
.border-y-8 {
  border-top-width: 8px;
  border-bottom-width: 8px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-b-8 {
  border-bottom-width: 8px;
}
.border-b-\\[6px\\] {
  border-bottom-width: 6px;
}
.border-e {
  border-inline-end-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-8 {
  border-left-width: 8px;
}
.border-l-\\[12px\\] {
  border-left-width: 12px;
}
.border-l-\\[6px\\] {
  border-left-width: 6px;
}
.border-l-\\[8px\\] {
  border-left-width: 8px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-r-4 {
  border-right-width: 4px;
}
.border-r-\\[6px\\] {
  border-right-width: 6px;
}
.border-r-\\[8px\\] {
  border-right-width: 8px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-8 {
  border-top-width: 8px;
}
.border-t-\\[6px\\] {
  border-top-width: 6px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[\\#2c2820\\] {
  --tw-border-opacity: 1;
  border-color: rgb(44 40 32 / var(--tw-border-opacity, 1));
}
.border-\\[\\#39ff14\\] {
  --tw-border-opacity: 1;
  border-color: rgb(57 255 20 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e2dfd8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 223 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ff00ff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 0 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ff5722\\]\\/20 {
  border-color: rgb(255 87 34 / 0.2);
}
.border-\\[var\\(--brand-primary\\)\\] {
  border-color: var(--brand-primary);
}
.border-\\[var\\(--brand-secondary\\)\\] {
  border-color: var(--brand-secondary);
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-amber-400\\/20 {
  border-color: rgb(251 191 36 / 0.2);
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-black\\/10 {
  border-color: rgb(0 0 0 / 0.1);
}
.border-black\\/5 {
  border-color: rgb(0 0 0 / 0.05);
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-blue-400\\/50 {
  border-color: rgb(96 165 250 / 0.5);
}
.border-blue-50 {
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/10 {
  border-color: rgb(59 130 246 / 0.1);
}
.border-blue-500\\/30 {
  border-color: rgb(59 130 246 / 0.3);
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}
.border-cyan-400 {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.border-cyan-500\\/30 {
  border-color: rgb(6 182 212 / 0.3);
}
.border-cyan-500\\/40 {
  border-color: rgb(6 182 212 / 0.4);
}
.border-cyan-600\\/50 {
  border-color: rgb(8 145 178 / 0.5);
}
.border-cyan-900 {
  --tw-border-opacity: 1;
  border-color: rgb(22 78 99 / var(--tw-border-opacity, 1));
}
.border-cyan-900\\/50 {
  border-color: rgb(22 78 99 / 0.5);
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-100\\/50 {
  border-color: rgb(209 250 229 / 0.5);
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity, 1));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-500\\/50 {
  border-color: rgb(16 185 129 / 0.5);
}
.border-emerald-800 {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}
.border-emerald-900 {
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/50 {
  border-color: rgb(199 210 254 / 0.5);
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/20 {
  border-color: rgb(99 102 241 / 0.2);
}
.border-indigo-500\\/50 {
  border-color: rgb(99 102 241 / 0.5);
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-indigo-700 {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity, 1));
}
.border-neutral-600 {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity, 1));
}
.border-neutral-700 {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity, 1));
}
.border-neutral-800 {
  --tw-border-opacity: 1;
  border-color: rgb(38 38 38 / var(--tw-border-opacity, 1));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-orange-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity, 1));
}
.border-pink-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-300 {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}
.border-pink-500\\/50 {
  border-color: rgb(236 72 153 / 0.5);
}
.border-primary-100 {
  --tw-border-opacity: 1;
  border-color: rgb(221 230 240 / var(--tw-border-opacity, 1));
}
.border-primary-200 {
  --tw-border-opacity: 1;
  border-color: rgb(188 205 224 / var(--tw-border-opacity, 1));
}
.border-primary-500\\/80 {
  border-color: rgb(0 45 114 / 0.8);
}
.border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(0 36 91 / var(--tw-border-opacity, 1));
}
.border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-50 {
  --tw-border-opacity: 1;
  border-color: rgb(254 242 242 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-rose-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-500\\/50 {
  border-color: rgb(244 63 94 / 0.5);
}
.border-slate-100 {
  border-color: oklch(96.8% 0.007 247.896);
}
.border-slate-200 {
  border-color: oklch(92.9% 0.013 255.508);
}
.border-slate-300 {
  border-color: oklch(86.9% 0.022 252.894);
}
.border-slate-400 {
  border-color: oklch(70.4% 0.04 256.788);
}
.border-slate-50 {
  border-color: oklch(98.4% 0.003 247.858);
}
.border-slate-600 {
  border-color: oklch(44.6% 0.043 257.281);
}
.border-slate-700 {
  border-color: oklch(37.2% 0.044 257.287);
}
.border-slate-800 {
  border-color: oklch(27.9% 0.041 260.031);
}
.border-slate-900 {
  border-color: oklch(20.8% 0.042 265.755);
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/5 {
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/50 {
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-y-transparent {
  border-top-color: transparent;
  border-bottom-color: transparent;
}
.border-b-slate-900 {
  border-bottom-color: oklch(20.8% 0.042 265.755);
}
.border-l-blue-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-indigo-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-blue-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-sky-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(2 132 199 / var(--tw-border-opacity, 1));
}
.border-t-slate-900 {
  border-top-color: oklch(20.8% 0.042 265.755);
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#0a0a0a\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0077b5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 119 181 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#010409\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 4 9 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#020617\\]\\/95 {
  background-color: rgb(2 6 23 / 0.95);
}
.bg-\\[\\#080b12\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 11 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B0C10\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 12 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B0F19\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 15 25 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F131E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 19 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0a0a0a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d1117\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 17 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\]\\/80 {
  background-color: rgb(15 23 42 / 0.8);
}
.bg-\\[\\#0f172a\\]\\/90 {
  background-color: rgb(15 23 42 / 0.9);
}
.bg-\\[\\#0f172a\\]\\/95 {
  background-color: rgb(15 23 42 / 0.95);
}
.bg-\\[\\#111111\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 17 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#161b22\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 27 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#171717\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e1e1e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e293b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#27c93f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(39 201 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#282c34\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 44 52 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FAFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d35230\\]\\/10 {
  background-color: rgb(211 82 48 / 0.1);
}
.bg-\\[\\#eff0f9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 240 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f2f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f5f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 245 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fcfbf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 251 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fdf4ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff5f56\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 95 86 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffbd2e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 189 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffde59\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 222 89 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--brand-primary\\)\\] {
  background-color: var(--brand-primary);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-400\\/10 {
  background-color: rgb(251 191 36 / 0.1);
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/50 {
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/20 {
  background-color: rgb(245 158 11 / 0.2);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-100\\/50 {
  background-color: rgb(219 234 254 / 0.5);
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-400\\/20 {
  background-color: rgb(96 165 250 / 0.2);
}
.bg-blue-400\\/50 {
  background-color: rgb(96 165 250 / 0.5);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/30 {
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/50 {
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10 {
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-500\\/20 {
  background-color: rgb(59 130 246 / 0.2);
}
.bg-blue-500\\/50 {
  background-color: rgb(59 130 246 / 0.5);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/10 {
  background-color: rgb(37 99 235 / 0.1);
}
.bg-blue-600\\/5 {
  background-color: rgb(37 99 235 / 0.05);
}
.bg-blue-900\\/20 {
  background-color: rgb(30 58 138 / 0.2);
}
.bg-blue-900\\/50 {
  background-color: rgb(30 58 138 / 0.5);
}
.bg-blue-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity, 1));
}
.bg-cyan-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity, 1));
}
.bg-cyan-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500\\/20 {
  background-color: rgb(6 182 212 / 0.2);
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-cyan-950\\/30 {
  background-color: rgb(8 51 68 / 0.3);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/10 {
  background-color: rgb(52 211 153 / 0.1);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/10 {
  background-color: rgb(236 253 245 / 0.1);
}
.bg-emerald-50\\/20 {
  background-color: rgb(236 253 245 / 0.2);
}
.bg-emerald-50\\/30 {
  background-color: rgb(236 253 245 / 0.3);
}
.bg-emerald-50\\/50 {
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/20 {
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity, 1));
}
.bg-emerald-900\\/30 {
  background-color: rgb(6 78 59 / 0.3);
}
.bg-emerald-900\\/90 {
  background-color: rgb(6 78 59 / 0.9);
}
.bg-emerald-950\\/30 {
  background-color: rgb(2 44 34 / 0.3);
}
.bg-fuchsia-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-500\\/20 {
  background-color: rgb(217 70 239 / 0.2);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/30 {
  background-color: rgb(249 250 251 / 0.3);
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-700\\/50 {
  background-color: rgb(55 65 81 / 0.5);
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/90 {
  background-color: rgb(17 24 39 / 0.9);
}
.bg-gray-900\\/95 {
  background-color: rgb(17 24 39 / 0.95);
}
.bg-gray-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/50 {
  background-color: rgb(240 253 244 / 0.5);
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-500\\/50 {
  background-color: rgb(34 197 94 / 0.5);
}
.bg-green-500\\/80 {
  background-color: rgb(34 197 94 / 0.8);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/10 {
  background-color: rgb(238 242 255 / 0.1);
}
.bg-indigo-50\\/30 {
  background-color: rgb(238 242 255 / 0.3);
}
.bg-indigo-50\\/50 {
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10 {
  background-color: rgb(99 102 241 / 0.1);
}
.bg-indigo-500\\/20 {
  background-color: rgb(99 102 241 / 0.2);
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600\\/40 {
  background-color: rgb(79 70 229 / 0.4);
}
.bg-indigo-600\\/5 {
  background-color: rgb(79 70 229 / 0.05);
}
.bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.bg-indigo-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity, 1));
}
.bg-indigo-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity, 1));
}
.bg-indigo-900\\/20 {
  background-color: rgb(49 46 129 / 0.2);
}
.bg-indigo-900\\/40 {
  background-color: rgb(49 46 129 / 0.4);
}
.bg-indigo-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity, 1));
}
.bg-neutral-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.bg-neutral-800\\/50 {
  background-color: rgb(38 38 38 / 0.5);
}
.bg-neutral-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-pink-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-pink-500\\/20 {
  background-color: rgb(236 72 153 / 0.2);
}
.bg-pink-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 230 240 / var(--tw-bg-opacity, 1));
}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 246 / var(--tw-bg-opacity, 1));
}
.bg-primary-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 45 114 / var(--tw-bg-opacity, 1));
}
.bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 91 / var(--tw-bg-opacity, 1));
}
.bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 27 68 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10 {
  background-color: rgb(168 85 247 / 0.1);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-purple-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-400\\/20 {
  background-color: rgb(248 113 113 / 0.2);
}
.bg-red-400\\/50 {
  background-color: rgb(248 113 113 / 0.5);
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/20 {
  background-color: rgb(254 242 242 / 0.2);
}
.bg-red-50\\/50 {
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/50 {
  background-color: rgb(239 68 68 / 0.5);
}
.bg-red-500\\/80 {
  background-color: rgb(239 68 68 / 0.8);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/20 {
  background-color: rgb(244 63 94 / 0.2);
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-sky-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  background-color: oklch(96.8% 0.007 247.896);
}
.bg-slate-200 {
  background-color: oklch(92.9% 0.013 255.508);
}
.bg-slate-300 {
  background-color: oklch(86.9% 0.022 252.894);
}
.bg-slate-400 {
  background-color: oklch(70.4% 0.04 256.788);
}
.bg-slate-50 {
  background-color: oklch(98.4% 0.003 247.858);
}
.bg-slate-500 {
  background-color: oklch(55.4% 0.046 257.417);
}
.bg-slate-600 {
  background-color: oklch(44.6% 0.043 257.281);
}
.bg-slate-700 {
  background-color: oklch(37.2% 0.044 257.287);
}
.bg-slate-800 {
  background-color: oklch(27.9% 0.041 260.031);
}
.bg-slate-900 {
  background-color: oklch(20.8% 0.042 265.755);
}
.bg-slate-950 {
  background-color: oklch(12.9% 0.042 264.695);
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/10 {
  background-color: rgb(139 92 246 / 0.1);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500\\/50 {
  background-color: rgb(234 179 8 / 0.5);
}
.bg-yellow-500\\/80 {
  background-color: rgb(234 179 8 / 0.8);
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-\\[linear-gradient\\(rgba\\(18\\2c 16\\2c 16\\2c 0\\)_50\\%\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)_50\\%\\)\\2c linear-gradient\\(90deg\\2c rgba\\(255\\2c 0\\2c 0\\2c 0\\.06\\)\\2c rgba\\(0\\2c 255\\2c 0\\2c 0\\.02\\)\\2c rgba\\(0\\2c 0\\2c 255\\2c 0\\.06\\)\\)\\] {
  background-image: linear-gradient(rgba(18,16,16,0) 50%,rgba(0,0,0,0.25) 50%),linear-gradient(90deg,rgba(255,0,0,0.06),rgba(0,255,0,0.02),rgba(0,0,255,0.06));
}
.bg-\\[radial-gradient\\(\\#f1f5f9_1px\\2c transparent_1px\\)\\] {
  background-image: radial-gradient(#f1f5f9 1px,transparent 1px);
}
.bg-\\[radial-gradient\\(ellipse_at_center\\2c _var\\(--tw-gradient-stops\\)\\)\\] {
  background-image: radial-gradient(ellipse at center, var(--tw-gradient-stops));
}
.bg-\\[url\\(\\'https\\:\\/\\/images\\.unsplash\\.com\\/photo-1451187580459-43490279c0fa\\?auto\\=format\\&fit\\=crop\\&q\\=80\\'\\)\\] {
  background-image: url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80');
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#020617\\] {
  --tw-gradient-from: #020617 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[var\\(--brand-primary\\)\\] {
  --tw-gradient-from: var(--brand-primary) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-200 {
  --tw-gradient-from: #fde68a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 230 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500 {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/0 {
  --tw-gradient-from: rgb(0 0 0 / 0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/60 {
  --tw-gradient-from: rgb(0 0 0 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80 {
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/90 {
  --tw-gradient-from: rgb(0 0 0 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/95 {
  --tw-gradient-from: rgb(0 0 0 / 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-100 {
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-200 {
  --tw-gradient-from: #bfdbfe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(191 219 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-700 {
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-900\\/80 {
  --tw-gradient-from: rgb(30 58 138 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-950\\/40 {
  --tw-gradient-from: rgb(23 37 84 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 37 84 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-900 {
  --tw-gradient-from: #064e3b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 78 59 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50 {
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-900 {
  --tw-gradient-from: #312e81 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-100 {
  --tw-gradient-from: #ffedd5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50 {
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500 {
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-900 {
  --tw-gradient-from: #7c2d12 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 45 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-400 {
  --tw-gradient-from: #7999BF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(121 153 191 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-200 {
  --tw-gradient-from: #e9d5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(233 213 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-900\\/80 {
  --tw-gradient-from: rgb(88 28 135 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-900 {
  --tw-gradient-from: #7f1d1d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(127 29 29 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-200 {
  --tw-gradient-from: oklch(92.9% 0.013 255.508) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: oklch(98.4% 0.003 247.858) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-700 {
  --tw-gradient-from: oklch(37.2% 0.044 257.287) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900 {
  --tw-gradient-from: oklch(20.8% 0.042 265.755) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/30 {
  --tw-gradient-from: rgb(255 255 255 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400 {
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#0B0C10\\] {
  --tw-gradient-to: rgb(11 12 16 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0B0C10 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/20 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/30 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/40 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/50 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/60 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500 {
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #3b82f6 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500\\/10 {
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(59 130 246 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-500\\/5 {
  --tw-gradient-to: rgb(59 130 246 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(59 130 246 / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-500 {
  --tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6366f1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-600 {
  --tw-gradient-to: rgb(79 70 229 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4f46e5 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-900 {
  --tw-gradient-to: rgb(88 28 135 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #581c87 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-500 {
  --tw-gradient-to: rgb(239 68 68 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ef4444 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#000000\\] {
  --tw-gradient-to: #000000 var(--tw-gradient-to-position);
}
.to-\\[var\\(--brand-secondary\\)\\] {
  --tw-gradient-to: var(--brand-secondary) var(--tw-gradient-to-position);
}
.to-black {
  --tw-gradient-to: #000 var(--tw-gradient-to-position);
}
.to-black\\/10 {
  --tw-gradient-to: rgb(0 0 0 / 0.1) var(--tw-gradient-to-position);
}
.to-black\\/20 {
  --tw-gradient-to: rgb(0 0 0 / 0.2) var(--tw-gradient-to-position);
}
.to-black\\/60 {
  --tw-gradient-to: rgb(0 0 0 / 0.6) var(--tw-gradient-to-position);
}
.to-blue-400 {
  --tw-gradient-to: #60a5fa var(--tw-gradient-to-position);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-cyan-400 {
  --tw-gradient-to: #22d3ee var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-emerald-500 {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-indigo-500 {
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-600 {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-700 {
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.to-orange-100 {
  --tw-gradient-to: #ffedd5 var(--tw-gradient-to-position);
}
.to-orange-200 {
  --tw-gradient-to: #fed7aa var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-600 {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600 {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-red-500 {
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-red-600 {
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-slate-100 {
  --tw-gradient-to: oklch(96.8% 0.007 247.896) var(--tw-gradient-to-position);
}
.to-slate-300 {
  --tw-gradient-to: oklch(86.9% 0.022 252.894) var(--tw-gradient-to-position);
}
.to-slate-800 {
  --tw-gradient-to: oklch(27.9% 0.041 260.031) var(--tw-gradient-to-position);
}
.to-slate-900 {
  --tw-gradient-to: oklch(20.8% 0.042 265.755) var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-600 {
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-white\\/40 {
  --tw-gradient-to: rgb(255 255 255 / 0.4) var(--tw-gradient-to-position);
}
.bg-\\[length\\:100\\%_4px\\2c 3px_100\\%\\] {
  background-size: 100% 4px,3px 100%;
}
.bg-cover {
  background-size: cover;
}
.bg-clip-text {
  background-clip: text;
}
.bg-center {
  background-position: center;
}
.fill-blue-600 {
  fill: #2563eb;
}
.fill-current {
  fill: currentColor;
}
.fill-white {
  fill: #fff;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.\\!p-4 {
  padding: 1rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-14 {
  padding: 3.5rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-20 {
  padding: 5rem;
}
.p-24 {
  padding: 6rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-32 {
  padding: 8rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[2px\\] {
  padding: 2px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-32 {
  padding-bottom: 8rem;
}
.pb-36 {
  padding-bottom: 9rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-40 {
  padding-bottom: 10rem;
}
.pb-44 {
  padding-bottom: 11rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-px {
  padding-bottom: 1px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-16 {
  padding-right: 4rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-7 {
  padding-inline-start: 1.75rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-display {
  font-family: Oswald, sans-serif;
}
.font-mono {
  font-family: JetBrains Mono, monospace;
}
.font-sans {
  font-family: Inter, sans-serif;
}
.font-serif {
  font-family: Merriweather, serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-8xl {
  font-size: 6rem;
  line-height: 1;
}
.text-9xl {
  font-size: 8rem;
  line-height: 1;
}
.text-\\[100px\\] {
  font-size: 100px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[110px\\] {
  font-size: 110px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[120px\\] {
  font-size: 120px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[12rem\\] {
  font-size: 12rem;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[250px\\] {
  font-size: 250px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[30rem\\] {
  font-size: 30rem;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[350px\\] {
  font-size: 350px;
}
.text-\\[35px\\] {
  font-size: 35px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[38px\\] {
  font-size: 38px;
}
.text-\\[400px\\] {
  font-size: 400px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[45px\\] {
  font-size: 45px;
}
.text-\\[50px\\] {
  font-size: 50px;
}
.text-\\[55px\\] {
  font-size: 55px;
}
.text-\\[65px\\] {
  font-size: 65px;
}
.text-\\[70px\\] {
  font-size: 70px;
}
.text-\\[75px\\] {
  font-size: 75px;
}
.text-\\[7px\\] {
  font-size: 7px;
}
.text-\\[800px\\] {
  font-size: 800px;
}
.text-\\[80px\\] {
  font-size: 80px;
}
.text-\\[85px\\] {
  font-size: 85px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[90px\\] {
  font-size: 90px;
}
.text-\\[95px\\] {
  font-size: 95px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-\\[9rem\\] {
  font-size: 9rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.font-thin {
  font-weight: 100;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.not-italic {
  font-style: normal;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[0\\.9\\] {
  line-height: 0.9;
}
.leading-\\[1\\.05\\] {
  line-height: 1.05;
}
.leading-\\[1\\.15\\] {
  line-height: 1.15;
}
.leading-\\[1\\.1\\] {
  line-height: 1.1;
}
.leading-\\[1\\.25\\] {
  line-height: 1.25;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\] {
  line-height: 1;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.3em\\] {
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#d4d4d4\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(212 212 212 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0077b5\\] {
  --tw-text-opacity: 1;
  color: rgb(0 119 181 / var(--tw-text-opacity, 1));
}
.text-\\[\\#111827\\] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1DA1F2\\] {
  --tw-text-opacity: 1;
  color: rgb(29 161 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a0dab\\] {
  --tw-text-opacity: 1;
  color: rgb(26 13 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2c2820\\] {
  --tw-text-opacity: 1;
  color: rgb(44 40 32 / var(--tw-text-opacity, 1));
}
.text-\\[\\#374151\\] {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#39ff14\\] {
  --tw-text-opacity: 1;
  color: rgb(57 255 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#484f58\\] {
  --tw-text-opacity: 1;
  color: rgb(72 79 88 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4a044e\\] {
  --tw-text-opacity: 1;
  color: rgb(74 4 78 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4d5156\\] {
  --tw-text-opacity: 1;
  color: rgb(77 81 86 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5c5549\\] {
  --tw-text-opacity: 1;
  color: rgb(92 85 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#701a75\\] {
  --tw-text-opacity: 1;
  color: rgb(112 26 117 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8b949e\\] {
  --tw-text-opacity: 1;
  color: rgb(139 148 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff00ff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff8a65\\] {
  --tw-text-opacity: 1;
  color: rgb(255 138 101 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--brand-primary\\)\\] {
  color: var(--brand-primary);
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-500\\/30 {
  color: rgb(59 130 246 / 0.3);
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-cyan-200 {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-500\\/50 {
  color: rgb(6 182 212 / 0.5);
}
.text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-fuchsia-400 {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-200 {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-indigo-800\\/50 {
  color: rgb(55 48 163 / 0.5);
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-indigo-950 {
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity, 1));
}
.text-neutral-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-pink-400 {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-primary-50 {
  --tw-text-opacity: 1;
  color: rgb(238 242 246 / var(--tw-text-opacity, 1));
}
.text-primary-500 {
  --tw-text-opacity: 1;
  color: rgb(0 45 114 / var(--tw-text-opacity, 1));
}
.text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(0 36 91 / var(--tw-text-opacity, 1));
}
.text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(0 27 68 / var(--tw-text-opacity, 1));
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-sky-100 {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity, 1));
}
.text-sky-300 {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-slate-100 {
  color: oklch(96.8% 0.007 247.896);
}
.text-slate-200 {
  color: oklch(92.9% 0.013 255.508);
}
.text-slate-300 {
  color: oklch(86.9% 0.022 252.894);
}
.text-slate-400 {
  color: oklch(70.4% 0.04 256.788);
}
.text-slate-50 {
  color: oklch(98.4% 0.003 247.858);
}
.text-slate-500 {
  color: oklch(55.4% 0.046 257.417);
}
.text-slate-600 {
  color: oklch(44.6% 0.043 257.281);
}
.text-slate-700 {
  color: oklch(37.2% 0.044 257.287);
}
.text-slate-800 {
  color: oklch(27.9% 0.041 260.031);
}
.text-slate-900 {
  color: oklch(20.8% 0.042 265.755);
}
.text-slate-950 {
  color: oklch(12.9% 0.042 264.695);
}
.text-transparent {
  color: transparent;
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/10 {
  color: rgb(255 255 255 / 0.1);
}
.text-white\\/30 {
  color: rgb(255 255 255 / 0.3);
}
.text-white\\/40 {
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-opacity-50 {
  --tw-text-opacity: 0.5;
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.decoration-green-300 {
  text-decoration-color: #86efac;
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.placeholder-emerald-300::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(110 231 183 / var(--tw-placeholder-opacity, 1));
}
.placeholder-indigo-300::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(165 180 252 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-200::placeholder {
  color: oklch(92.9% 0.013 255.508);
}
.placeholder-slate-300::placeholder {
  color: oklch(86.9% 0.022 252.894);
}
.placeholder-slate-400::placeholder {
  color: oklch(70.4% 0.04 256.788);
}
.accent-amber-500 {
  accent-color: #f59e0b;
}
.accent-blue-600 {
  accent-color: #2563eb;
}
.accent-cyan-500 {
  accent-color: #06b6d4;
}
.accent-emerald-500 {
  accent-color: #10b981;
}
.accent-fuchsia-500 {
  accent-color: #d946ef;
}
.accent-indigo-500 {
  accent-color: #6366f1;
}
.accent-indigo-600 {
  accent-color: #4f46e5;
}
.accent-pink-500 {
  accent-color: #ec4899;
}
.accent-rose-500 {
  accent-color: #f43f5e;
}
.accent-slate-300 {
  accent-color: oklch(86.9% 0.022 252.894);
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-5 {
  opacity: 0.05;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-95 {
  opacity: 0.95;
}
.opacity-\\[0\\.03\\] {
  opacity: 0.03;
}
.opacity-\\[0\\.07\\] {
  opacity: 0.07;
}
.opacity-\\[0\\.08\\] {
  opacity: 0.08;
}
.mix-blend-multiply {
  mix-blend-mode: multiply;
}
.mix-blend-screen {
  mix-blend-mode: screen;
}
.mix-blend-overlay {
  mix-blend-mode: overlay;
}
.mix-blend-luminosity {
  mix-blend-mode: luminosity;
}
.mix-blend-plus-lighter {
  mix-blend-mode: plus-lighter;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-30px_0_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: -30px 0 80px rgba(0,0,0,0.5);
  --tw-shadow-colored: -30px 0 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_4px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 0 0 4px rgba(99,102,241,0.2);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_6px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 0 0 6px rgba(99,102,241,0.3);
  --tw-shadow-colored: 0 0 0 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_8px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 0 0 8px rgba(99,102,241,0.3);
  --tw-shadow-colored: 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_8px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 0 0 8px rgba(99,102,241,0.5);
  --tw-shadow-colored: 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_100px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 0 100px rgba(255,255,255,0.1);
  --tw-shadow-colored: 0 0 100px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_\\#10b981\\] {
  --tw-shadow: 0 0 10px #10b981;
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(129\\2c 140\\2c 248\\2c 1\\)\\2c 0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.8\\)\\] {
  --tw-shadow: 0 0 10px rgba(129,140,248,1),0 0 2px rgba(255,255,255,0.8);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color), 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(96\\2c 165\\2c 250\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 0 10px rgba(96,165,250,0.5);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 0 10px rgba(99,102,241,0.5);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_150px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\] {
  --tw-shadow: 0 0 150px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 0 150px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_15px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 0 15px rgba(16,185,129,0.4);
  --tw-shadow-colored: 0 0 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 0 20px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 0 20px rgba(16,185,129,0.3);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 0 20px rgba(16,185,129,0.6);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_20px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 0 20px rgba(99,102,241,0.4);
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_30px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 0 30px rgba(59,130,246,0.2);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(16\\2c 185\\2c 129\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 0 40px rgba(16,185,129,0.1);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_50px_rgba\\(8\\2c 145\\2c 178\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 0 50px rgba(8,145,178,0.2);
  --tw-shadow-colored: 0 0 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 0 8px rgba(99,102,241,0.4);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 10px 40px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 20px 40px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 20px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 20px 50px -12px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 20px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 20px 50px rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 20px 50px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_-15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 20px 60px -15px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 20px 60px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.7);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\] {
  --tw-shadow: 0 20px 60px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_60px_-15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 30px 60px -15px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 30px 60px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 30px 60px rgba(0,0,0,0.6);
  --tw-shadow-colored: 0 30px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_70px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\] {
  --tw-shadow: 0 30px 70px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 30px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 30px 80px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 30px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_35px_60px_-15px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 35px 60px -15px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 35px 60px -15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_40px_100px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 40px 100px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 40px 100px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 4px 10px rgba(0,0,0,0.3);
  --tw-shadow-colored: 0 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_32px_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 8px 32px 0 rgba(255,255,255,0.1);
  --tw-shadow-colored: 0 8px 32px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[15px_15px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.3\\)\\] {
  --tw-shadow: 15px 15px 0px 0px rgba(0,0,0,0.3);
  --tw-shadow-colored: 15px 15px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[15px_15px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 15px 15px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 15px 15px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[16px_16px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 16px 16px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 16px 16px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[20px_20px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 20px 20px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 20px 20px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[30px_30px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 30px 30px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 30px 30px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[4px_4px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 4px 4px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 4px 4px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[5px_5px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 5px 5px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 5px 5px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[6px_6px_0px_0px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-shadow: 6px 6px 0px 0px rgba(0,0,0,1);
  --tw-shadow-colored: 6px 6px 0px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_8px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.5\\)\\] {
  --tw-shadow: inset 0 0 0 8px rgba(99,102,241,0.5);
  --tw-shadow-colored: inset 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_8px_rgba\\(99\\2c 102\\2c 241\\2c 1\\)\\] {
  --tw-shadow: inset 0 0 0 8px rgba(99,102,241,1);
  --tw-shadow-colored: inset 0 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-100 {
  --tw-shadow-color: #dbeafe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-200 {
  --tw-shadow-color: #bfdbfe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-300 {
  --tw-shadow-color: #93c5fd;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-900\\/20 {
  --tw-shadow-color: rgb(30 58 138 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-900\\/50 {
  --tw-shadow-color: rgb(30 58 138 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-100 {
  --tw-shadow-color: #d1fae5;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-200 {
  --tw-shadow-color: #a7f3d0;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-100 {
  --tw-shadow-color: #e0e7ff;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200 {
  --tw-shadow-color: #c7d2fe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-200 {
  --tw-shadow-color: oklch(92.9% 0.013 255.508);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-300 {
  --tw-shadow-color: oklch(86.9% 0.022 252.894);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-white\\/10 {
  --tw-shadow-color: rgb(255 255 255 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-white\\/5 {
  --tw-shadow-color: rgb(255 255 255 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-amber-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}
.ring-black\\/10 {
  --tw-ring-color: rgb(0 0 0 / 0.1);
}
.ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.ring-blue-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.ring-blue-500\\/10 {
  --tw-ring-color: rgb(59 130 246 / 0.1);
}
.ring-emerald-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.ring-indigo-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.ring-indigo-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.ring-indigo-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 242 255 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.ring-indigo-500\\/30 {
  --tw-ring-color: rgb(99 102 241 / 0.3);
}
.ring-pink-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 72 153 / var(--tw-ring-opacity, 1));
}
.ring-red-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.ring-white\\/10 {
  --tw-ring-color: rgb(255 255 255 / 0.1);
}
.ring-white\\/20 {
  --tw-ring-color: rgb(255 255 255 / 0.2);
}
.ring-white\\/5 {
  --tw-ring-color: rgb(255 255 255 / 0.05);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\] {
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[10px\\] {
  --tw-blur: blur(10px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[110px\\] {
  --tw-blur: blur(110px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[120px\\] {
  --tw-blur: blur(120px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[150px\\] {
  --tw-blur: blur(150px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[2px\\] {
  --tw-blur: blur(2px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[60px\\] {
  --tw-blur: blur(60px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[80px\\] {
  --tw-blur: blur(80px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md {
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-0 {
  --tw-brightness: brightness(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.contrast-125 {
  --tw-contrast: contrast(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-2xl {
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-xl {
  --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia {
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-3xl {
  --tw-backdrop-blur: blur(64px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-1000 {
  transition-delay: 1000ms;
}
.delay-150 {
  transition-delay: 150ms;
}
.delay-200 {
  transition-delay: 200ms;
}
.delay-300 {
  transition-delay: 300ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-\\[2s\\] {
  transition-duration: 2s;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-transform {
  will-change: transform;
}
.\\[--auto-close\\:lg\\] {
  --auto-close: lg;
}
.\\[-ms-overflow-style\\:none\\] {
  -ms-overflow-style: none;
}
.\\[animation-delay\\:-0\\.15s\\] {
  animation-delay: -0.15s;
}
.\\[animation-delay\\:-0\\.3s\\] {
  animation-delay: -0.3s;
}
.\\[background-size\\:20px_20px\\] {
  background-size: 20px 20px;
}
.\\[mask-image\\:linear-gradient\\(to_right\\2c transparent\\2c black_2\\%\\2c black_98\\%\\2c transparent\\)\\] {
  mask-image: linear-gradient(to right,transparent,black 2%,black 98%,transparent);
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
.\\[text-shadow\\:0_0_1px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.9\\)\\] {
  text-shadow: 0 0 1px rgba(0,0,0,0.9);
}
.\\[text-shadow\\:0_0_1px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.9\\)\\] {
  text-shadow: 0 0 1px rgba(255,255,255,0.9);
}

/* =========================================
   COMPONENT LAYER (Tailwind Managed)
   ========================================= */ /* --- END @LAYER COMPONENTS --- */

/* =========================================
   GLOBAL OVERRIDES (Must be outside layer)
   ========================================= */

/* 1. THE 2-COLUMN ENGINE (FORCE TRIGGER) */
/* We target the editor (.ProseMirror) and the preview (.content) */
[data-layout="double"] .ProseMirror,
[data-layout="double"] .content,
[data-layout="double"] #reportBody {
  display: block !important; /* 🚀 Critical: Columns fail on flex/grid containers */
  column-count: 2 !important;
  column-gap: 40px !important;
  column-fill: auto;
  text-align: justify;
  width: 100% !important;
}

/* 2. BREAKOUT ELEMENTS (Span across both columns) */
[data-layout="double"] h1,
[data-layout="double"] .article-header,
[data-layout="double"] .exec-summary,
[data-layout="double"] .full-width,
[data-layout="double"] .cover-page,
[data-layout="double"] .article-title {
  column-span: all !important;
  -webkit-column-span: all !important;
  width: 100% !important;
  clear: both;
  display: block;
}

/* 3. DYNAMIC LAYOUT ENGINE (UNIVERSAL) */
/* 🚀 Universal Wrapper for Tables, Charts, Insights, Risk Boxes */
.ProseMirror .tableWrapper,
.ProseMirror .layout-wrapper,
.tableWrapper,
.layout-wrapper,
.scientific-chart-wrapper {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  width: 100%;
  clear: both;
  position: relative; /* Needed for editor badges */
}

/* --- A. EDITOR VISUALIZATION (Single Column Context) --- */
/* When editing, we simulate "Column Fit" with a visual shrink & badge */
.ProseMirror .layout-wrapper[data-layout="half"],
.ProseMirror .tableWrapper[data-layout="half"],
.ProseMirror .scientific-chart-wrapper[data-layout="half"] {
  width: 60% !important; /* Visually shrink to indicate it won't be full width */
  margin-left: auto !important; /* Push right */ border-radius: 0.5rem; border-width: 2px; border-style: dashed; border-color: oklch(92.9% 0.013 255.508); background-color: oklch(98.4% 0.003 247.858); --tw-bg-opacity: 0.5; padding: 0.5rem;
}

.ProseMirror .layout-wrapper[data-layout="half"]::after,
.ProseMirror .tableWrapper[data-layout="half"]::after,
.ProseMirror .scientific-chart-wrapper[data-layout="half"]::after {
    content: "FIT COLUMN";
    position: absolute;
    top: -0.625rem;
    right: 0.5rem;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 0.25rem;
    background-color: oklch(92.9% 0.013 255.508);
    padding-left: 0.375rem;
    padding-right: 0.375rem;
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: oklch(55.4% 0.046 257.417);
}

/* --- B. PDF / PREVIEW LAYOUT (2-Column Context) --- */

/* FULL WIDTH: Breaks out to span both columns */
[data-layout="double"] .tableWrapper:has(table[data-layout="full"]),
[data-layout="double"] .tableWrapper:not(:has(table[data-layout])),
[data-layout="double"] .layout-wrapper[data-layout="full"],
[data-layout="double"] .scientific-chart-wrapper[data-layout="full"] {
  column-span: all !important;
  -webkit-column-span: all !important;
  width: 100% !important;
}

/* HALF WIDTH: Captured inside a single column */
[data-layout="double"] .tableWrapper:has(table[data-layout="half"]),
[data-layout="double"] .layout-wrapper[data-layout="half"],
[data-layout="double"] .scientific-chart-wrapper[data-layout="half"] {
  column-span: none !important;
  -webkit-column-span: none !important;
  width: 100% !important; 
  float: none !important;
  margin-left: 0;
  border-radius: 0.5rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / var(--tw-border-opacity, 1));
  background-color: rgb(238 242 255 / 0.1);
  padding: 0.25rem;
}

/* --- C. PDF / PREVIEW LAYOUT (1-Column Context) --- */
/* SINGLE COLUMN DOC FALLBACK: 50% Float Right */
[data-layout="single"] .tableWrapper:has(table[data-layout="half"]),
[data-layout="single"] .layout-wrapper[data-layout="half"],
[data-layout="single"] .scientific-chart-wrapper[data-layout="half"] {
  width: 50% !important;
  float: right;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

/* 4. TIPTAP WYSIWYG FIXES */
.ProseMirror td p, .ProseMirror th p { margin: 0 !important; }

/* Insight/Risk boxes inside layout-wrappers need flex */
.ProseMirror .layout-wrapper .insight-box, 
.ProseMirror .layout-wrapper .risk-box {
  display: flex; gap: 12px; padding: 16px; border-radius: 4px; margin: 0;
}

.ProseMirror .insight-box { background: #f0f9ff; border-left: 4px solid #0ea5e9; }
.ProseMirror .risk-box { background: #fef2f2; border-left: 4px solid #ef4444; }

/* 5. SCIENTIFIC CHART FIXES */
.ProseMirror div[data-type="scientific-chart"] {
  display: block !important;
  min-height: 400px;
  width: 100% !important;
}

.scientific-chart-node {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
}

/* --- CHART LAYOUT LOGIC (FIXED) --- */

/* 1. Base Wrapper */
.scientific-chart-wrapper {
  margin: 2rem 0;
  width: 100%;
  page-break-inside: avoid;
  break-inside: avoid;
}

/* 2. FULL WIDTH (Breaks out across 2 cols) */
[data-layout="double"] .scientific-chart-wrapper[data-layout="full"],
[data-layout="double"] .scientific-chart-wrapper:not([data-layout]) {
  column-span: all !important;
  -webkit-column-span: all !important;
  width: 100% !important;
}

/* 3. HALF WIDTH (Trapped in column) */
[data-layout="double"] .scientific-chart-wrapper[data-layout="half"] {
  column-span: none !important;
  -webkit-column-span: none !important;
  width: 100% !important; /* Takes full width of the *column* */
  float: none !important;
}

/* 4. EDITOR VISUALIZATION (Single Column Context) */
/* This makes it visually shrink in the editor so you know it's "Fit Column" */
.ProseMirror .scientific-chart-wrapper[data-layout="half"] {
  width: 60% !important;
  margin-left: auto !important;
  border-radius: 0.5rem;
  border-width: 2px;
  border-style: dashed;
  border-color: oklch(92.9% 0.013 255.508);
  background-color: oklch(98.4% 0.003 247.858);
  --tw-bg-opacity: 0.5;
  padding: 0.5rem;
  position: relative;
}

.ProseMirror .scientific-chart-wrapper[data-layout="half"]::after {
    content: "FIT COLUMN";
    position: absolute;
    top: -0.625rem;
    right: 0.5rem;
    -webkit-user-select: none;
            user-select: none;
    border-radius: 0.25rem;
    background-color: oklch(92.9% 0.013 255.508);
    padding-left: 0.375rem;
    padding-right: 0.375rem;
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: oklch(55.4% 0.046 257.417);
}


/* Page Guides for TipTap Editor */
.show-page-guides .ProseMirror {
  /* 1056px is roughly 11 inches at 96 DPI */
  background-image: linear-gradient(
    to bottom, 
    transparent 1055px, 
    #cbd5e1 1055px, 
    #cbd5e1 1056px
  );
  background-size: 100% 1056px;
  min-height: 1056px; /* Ensure at least one page is visible */
}

/* Double layout */
.layout-double {
  column-count: 2;
  column-gap: 3rem;
  column-rule: 1px solid #e2e8f0; /* Optional line between columns */
}

.layout-double h1, 
.layout-double h2, 
.layout-double figure {
  page-break-inside: avoid;
  break-inside: avoid;
  /* Make big headers span across both columns! */
  column-span: all; 
}

/* Custom Image Shapes */
.clip-path-slant {
  clip-path: polygon(0 0, 100% 0, 100% 85%, 0 100%);
}

/* =========================================
   CANVAS TIPTAP EDITOR (Slide Text Boxes)
   ========================================= */
/*  Prevent global ProseMirror rules from adding 400px of padding! */
.tiptap-canvas-editor .ProseMirror {
  min-height: auto !important;
  padding-bottom: 0 !important;
}

/* THE BASELINE SHIFT FIX: 
   Forces Tiptap color spans to lock perfectly to the paragraph's baseline 
   without altering the line-height or vertical flow. 
*/
.tiptap-canvas-editor .ProseMirror span {
  vertical-align: baseline !important;
  line-height: inherit !important;
  display: inline !important;
  margin: 0 !important;
  padding: 0 !important;
}

.tiptap-canvas-editor p {
  margin: 0;
  line-height: 1.2;
}

.tiptap-canvas-editor p.is-editor-empty:first-child::before {
  color: #adb5bd;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}
.tiptap-canvas-editor ul {
  list-style-type: disc;
  padding-left: 1.25em;
  margin: 0;
}
.tiptap-canvas-editor ol {
  list-style-type: decimal;
  padding-left: 1.25em;
  margin: 0;
}
.tiptap-canvas-editor strong {
  font-weight: 900; 
}


/* --- PRESENTATION ANIMATIONS --- */
.animate-fade-in { animation: fadeIn 0.8s ease-out both; }
.animate-slide-up { animation: slideUp 0.8s ease-out both; }
.animate-slide-left { animation: slideLeft 0.8s ease-out both; }
.animate-zoom-in { animation: zoomIn 0.8s ease-out both; }
.animate-pop { animation: pop 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) both; }

@keyframes fadeIn { 
  from { opacity: 0; } 
  to { opacity: var(--target-opacity, 1); } 
}
@keyframes slideUp { 
  from { opacity: 0; transform: translateY(40px); } 
  to { opacity: var(--target-opacity, 1); transform: translateY(0); } 
}
@keyframes slideLeft { 
  from { opacity: 0; transform: translateX(40px); } 
  to { opacity: var(--target-opacity, 1); transform: translateX(0); } 
}
@keyframes zoomIn { 
  from { opacity: 0; transform: scale(0.8); } 
  to { opacity: var(--target-opacity, 1); transform: scale(1); } 
}
@keyframes pop { 
  0% { opacity: 0; transform: scale(0.5); } 
  80% { transform: scale(1.05); } 
  100% { opacity: var(--target-opacity, 1); transform: scale(1); } 
}

.delay-0 { animation-delay: 0ms; }
.delay-500 { animation-delay: 500ms; }
.delay-1000 { animation-delay: 1000ms; }
.delay-1500 { animation-delay: 1500ms; }
.delay-2000 { animation-delay: 2000ms; }
.delay-2500 { animation-delay: 2500ms; }
.delay-3000 { animation-delay: 3000ms; }
.dark\\:prose-invert:is(.dark *) {
  --tw-prose-body: var(--tw-prose-invert-body);
  --tw-prose-headings: var(--tw-prose-invert-headings);
  --tw-prose-lead: var(--tw-prose-invert-lead);
  --tw-prose-links: var(--tw-prose-invert-links);
  --tw-prose-bold: var(--tw-prose-invert-bold);
  --tw-prose-counters: var(--tw-prose-invert-counters);
  --tw-prose-bullets: var(--tw-prose-invert-bullets);
  --tw-prose-hr: var(--tw-prose-invert-hr);
  --tw-prose-quotes: var(--tw-prose-invert-quotes);
  --tw-prose-quote-borders: var(--tw-prose-invert-quote-borders);
  --tw-prose-captions: var(--tw-prose-invert-captions);
  --tw-prose-kbd: var(--tw-prose-invert-kbd);
  --tw-prose-kbd-shadows: var(--tw-prose-invert-kbd-shadows);
  --tw-prose-code: var(--tw-prose-invert-code);
  --tw-prose-pre-code: var(--tw-prose-invert-pre-code);
  --tw-prose-pre-bg: var(--tw-prose-invert-pre-bg);
  --tw-prose-th-borders: var(--tw-prose-invert-th-borders);
  --tw-prose-td-borders: var(--tw-prose-invert-td-borders);
}
@media (min-width: 640px) {
  .sm\\:prose-base {
    font-size: 1rem;
    line-height: 1.75;
  }
  .sm\\:prose-base :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .sm\\:prose-base :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }
  .sm\\:prose-base :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-inline-start: 1em;
  }
  .sm\\:prose-base :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }
  .sm\\:prose-base :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }
  .sm\\:prose-base :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }
  .sm\\:prose-base :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }
  .sm\\:prose-base :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-base :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-base :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose-base :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-base :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
    border-radius: 0.3125rem;
    padding-top: 0.1875em;
    padding-inline-end: 0.375em;
    padding-bottom: 0.1875em;
    padding-inline-start: 0.375em;
  }
  .sm\\:prose-base :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
  }
  .sm\\:prose-base :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
  }
  .sm\\:prose-base :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.9em;
  }
  .sm\\:prose-base :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-inline-end: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-inline-start: 1.1428571em;
  }
  .sm\\:prose-base :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
    padding-inline-start: 1.625em;
  }
  .sm\\:prose-base :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
    padding-inline-start: 1.625em;
  }
  .sm\\:prose-base :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .sm\\:prose-base :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0.375em;
  }
  .sm\\:prose-base :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0.375em;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-bottom: 1.25em;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-bottom: 1.25em;
  }
  .sm\\:prose-base :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  .sm\\:prose-base :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }
  .sm\\:prose-base :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.25em;
  }
  .sm\\:prose-base :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.5em;
    padding-inline-start: 1.625em;
  }
  .sm\\:prose-base :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 3em;
    margin-bottom: 3em;
  }
  .sm\\:prose-base :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .sm\\:prose-base :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .sm\\:prose-base :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .sm\\:prose-base :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .sm\\:prose-base :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
    line-height: 1.7142857;
  }
  .sm\\:prose-base :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-end: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-inline-start: 0.5714286em;
  }
  .sm\\:prose-base :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0;
  }
  .sm\\:prose-base :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-end: 0;
  }
  .sm\\:prose-base :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-top: 0.5714286em;
    padding-inline-end: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-inline-start: 0.5714286em;
  }
  .sm\\:prose-base :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0;
  }
  .sm\\:prose-base :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-end: 0;
  }
  .sm\\:prose-base :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .sm\\:prose-base :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
    margin-bottom: 0;
  }
  .sm\\:prose-base :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .sm\\:prose-base :where(.sm\\:prose-base > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-bottom: 0;
  }
}
@media (min-width: 1024px) {
  .lg\\:prose-lg {
    font-size: 1.125rem;
    line-height: 1.7777778;
  }
  .lg\\:prose-lg :where(p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg :where([class~="lead"]):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }
  .lg\\:prose-lg :where(blockquote):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-inline-start: 1em;
  }
  .lg\\:prose-lg :where(h1):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }
  .lg\\:prose-lg :where(h2):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }
  .lg\\:prose-lg :where(h3):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }
  .lg\\:prose-lg :where(h4):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }
  .lg\\:prose-lg :where(img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg :where(picture):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg :where(picture > img):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose-lg :where(video):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg :where(kbd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.8888889em;
    border-radius: 0.3125rem;
    padding-top: 0.2222222em;
    padding-inline-end: 0.4444444em;
    padding-bottom: 0.2222222em;
    padding-inline-start: 0.4444444em;
  }
  .lg\\:prose-lg :where(code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.8888889em;
  }
  .lg\\:prose-lg :where(h2 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.8666667em;
  }
  .lg\\:prose-lg :where(h3 code):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.875em;
  }
  .lg\\:prose-lg :where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-inline-end: 1.5em;
    padding-bottom: 1em;
    padding-inline-start: 1.5em;
  }
  .lg\\:prose-lg :where(ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-inline-start: 1.5555556em;
  }
  .lg\\:prose-lg :where(ul):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-inline-start: 1.5555556em;
  }
  .lg\\:prose-lg :where(li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }
  .lg\\:prose-lg :where(ol > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0.4444444em;
  }
  .lg\\:prose-lg :where(ul > li):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0.4444444em;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > ul > li p):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > ul > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > ul > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > ol > li > p:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > ol > li > p:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg :where(ul ul, ul ol, ol ul, ol ol):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }
  .lg\\:prose-lg :where(dl):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }
  .lg\\:prose-lg :where(dt):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.3333333em;
  }
  .lg\\:prose-lg :where(dd):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0.6666667em;
    padding-inline-start: 1.5555556em;
  }
  .lg\\:prose-lg :where(hr):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }
  .lg\\:prose-lg :where(hr + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .lg\\:prose-lg :where(h2 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .lg\\:prose-lg :where(h3 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .lg\\:prose-lg :where(h4 + *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .lg\\:prose-lg :where(table):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.8888889em;
    line-height: 1.5;
  }
  .lg\\:prose-lg :where(thead th):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-end: 0.75em;
    padding-bottom: 0.75em;
    padding-inline-start: 0.75em;
  }
  .lg\\:prose-lg :where(thead th:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0;
  }
  .lg\\:prose-lg :where(thead th:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-end: 0;
  }
  .lg\\:prose-lg :where(tbody td, tfoot td):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-top: 0.75em;
    padding-inline-end: 0.75em;
    padding-bottom: 0.75em;
    padding-inline-start: 0.75em;
  }
  .lg\\:prose-lg :where(tbody td:first-child, tfoot td:first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-start: 0;
  }
  .lg\\:prose-lg :where(tbody td:last-child, tfoot td:last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    padding-inline-end: 0;
  }
  .lg\\:prose-lg :where(figure):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }
  .lg\\:prose-lg :where(figure > *):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
    margin-bottom: 0;
  }
  .lg\\:prose-lg :where(figcaption):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > :first-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-top: 0;
  }
  .lg\\:prose-lg :where(.lg\\:prose-lg > :last-child):not(:where([class~="not-prose"],[class~="not-prose"] *)) {
    margin-bottom: 0;
  }
}
.selection\\:bg-blue-100 *::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-indigo-100 *::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.selection\\:text-indigo-900 *::selection {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.selection\\:bg-blue-100::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.selection\\:bg-indigo-100::selection {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.selection\\:text-indigo-900::selection {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.file\\:mr-4::file-selector-button {
  margin-right: 1rem;
}
.file\\:rounded-md::file-selector-button {
  border-radius: 0.375rem;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-indigo-50::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:py-1::file-selector-button {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.file\\:text-\\[10px\\]::file-selector-button {
  font-size: 10px;
}
.file\\:font-bold::file-selector-button {
  font-weight: 700;
}
.file\\:text-indigo-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-200::placeholder {
  color: oklch(92.9% 0.013 255.508);
}
.placeholder\\:text-slate-300::placeholder {
  color: oklch(86.9% 0.022 252.894);
}
.placeholder\\:text-slate-400::placeholder {
  color: oklch(70.4% 0.04 256.788);
}
.placeholder\\:text-slate-500::placeholder {
  color: oklch(55.4% 0.046 257.417);
}
.placeholder\\:text-slate-600::placeholder {
  color: oklch(44.6% 0.043 257.281);
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:mr-0:last-child {
  margin-right: 0px;
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.last\\:pb-0:last-child {
  padding-bottom: 0px;
}
.empty\\:before\\:opacity-30:empty::before {
  content: var(--tw-content);
  opacity: 0.3;
}
.empty\\:before\\:content-\\[\\'Type_here\\.\\.\\.\\'\\]:empty::before {
  --tw-content: 'Type here...';
  content: var(--tw-content);
}
.focus-within\\:border-indigo-400:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-4:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-blue-500\\/10:focus-within {
  --tw-ring-color: rgb(59 130 246 / 0.1);
}
.focus-within\\:ring-indigo-400:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-indigo-500\\/30:focus-within {
  --tw-ring-color: rgb(99 102 241 / 0.3);
}
.hover\\:z-30:hover {
  z-index: 30;
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-y-0\\.5:hover {
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-95:hover {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:cursor-grab:hover {
  cursor: grab;
}
.hover\\:gap-4:hover {
  gap: 1rem;
}
.hover\\:border-\\[\\#ff5722\\]\\/40:hover {
  border-color: rgb(255 87 34 / 0.4);
}
.hover\\:border-amber-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.hover\\:border-black\\/10:hover {
  border-color: rgb(0 0 0 / 0.1);
}
.hover\\:border-black\\/20:hover {
  border-color: rgb(0 0 0 / 0.2);
}
.hover\\:border-black\\/5:hover {
  border-color: rgb(0 0 0 / 0.05);
}
.hover\\:border-blue-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.hover\\:border-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-500\\/30:hover {
  border-color: rgb(16 185 129 / 0.3);
}
.hover\\:border-indigo-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-500\\/40:hover {
  border-color: rgb(99 102 241 / 0.4);
}
.hover\\:border-indigo-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.hover\\:border-neutral-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(154 179 208 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(121 153 191 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 45 114 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-500\\/30:hover {
  border-color: rgb(239 68 68 / 0.3);
}
.hover\\:border-rose-500\\/50:hover {
  border-color: rgb(244 63 94 / 0.5);
}
.hover\\:border-slate-100:hover {
  border-color: oklch(96.8% 0.007 247.896);
}
.hover\\:border-slate-200:hover {
  border-color: oklch(92.9% 0.013 255.508);
}
.hover\\:border-slate-300:hover {
  border-color: oklch(86.9% 0.022 252.894);
}
.hover\\:border-slate-400:hover {
  border-color: oklch(70.4% 0.04 256.788);
}
.hover\\:border-slate-500:hover {
  border-color: oklch(55.4% 0.046 257.417);
}
.hover\\:border-slate-600:hover {
  border-color: oklch(44.6% 0.043 257.281);
}
.hover\\:border-slate-700:hover {
  border-color: oklch(37.2% 0.044 257.287);
}
.hover\\:border-slate-800:hover {
  border-color: oklch(27.9% 0.041 260.031);
}
.hover\\:border-white\\/10:hover {
  border-color: rgb(255 255 255 / 0.1);
}
.hover\\:border-white\\/20:hover {
  border-color: rgb(255 255 255 / 0.2);
}
.hover\\:border-white\\/30:hover {
  border-color: rgb(255 255 255 / 0.3);
}
.hover\\:border-white\\/40:hover {
  border-color: rgb(255 255 255 / 0.4);
}
.hover\\:border-white\\/5:hover {
  border-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-\\[\\#005582\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 85 130 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d35230\\]\\/20:hover {
  background-color: rgb(211 82 48 / 0.2);
}
.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50\\/30:hover {
  background-color: rgb(239 246 255 / 0.3);
}
.hover\\:bg-blue-50\\/50:hover {
  background-color: rgb(239 246 255 / 0.5);
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-500\\/20:hover {
  background-color: rgb(6 182 212 / 0.2);
}
.hover\\:bg-cyan-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-600\\/30:hover {
  background-color: rgb(8 145 178 / 0.3);
}
.hover\\:bg-cyan-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50\\/10:hover {
  background-color: rgb(236 253 245 / 0.1);
}
.hover\\:bg-emerald-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-500\\/30:hover {
  background-color: rgb(16 185 129 / 0.3);
}
.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100\\/20:hover {
  background-color: rgb(243 244 246 / 0.2);
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50\\/20:hover {
  background-color: rgb(238 242 255 / 0.2);
}
.hover\\:bg-indigo-50\\/30:hover {
  background-color: rgb(238 242 255 / 0.3);
}
.hover\\:bg-indigo-50\\/40:hover {
  background-color: rgb(238 242 255 / 0.4);
}
.hover\\:bg-indigo-50\\/50:hover {
  background-color: rgb(238 242 255 / 0.5);
}
.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-500\\/20:hover {
  background-color: rgb(99 102 241 / 0.2);
}
.hover\\:bg-indigo-500\\/30:hover {
  background-color: rgb(99 102 241 / 0.3);
}
.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-neutral-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-neutral-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 45 114 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 91 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 27 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50\\/10:hover {
  background-color: rgb(254 242 242 / 0.1);
}
.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500\\/20:hover {
  background-color: rgb(239 68 68 / 0.2);
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-500\\/20:hover {
  background-color: rgb(244 63 94 / 0.2);
}
.hover\\:bg-sky-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover {
  background-color: oklch(96.8% 0.007 247.896);
}
.hover\\:bg-slate-200:hover {
  background-color: oklch(92.9% 0.013 255.508);
}
.hover\\:bg-slate-300:hover {
  background-color: oklch(86.9% 0.022 252.894);
}
.hover\\:bg-slate-50:hover {
  background-color: oklch(98.4% 0.003 247.858);
}
.hover\\:bg-slate-700:hover {
  background-color: oklch(37.2% 0.044 257.287);
}
.hover\\:bg-slate-800:hover {
  background-color: oklch(27.9% 0.041 260.031);
}
.hover\\:bg-slate-900:hover {
  background-color: oklch(20.8% 0.042 265.755);
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-yellow-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.hover\\:text-amber-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-600:hover {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-400:hover {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-500:hover {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-300:hover {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-400:hover {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-fuchsia-400:hover {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-50:hover {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-300:hover {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-400:hover {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-neutral-300:hover {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.hover\\:text-orange-700:hover {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-400:hover {
  --tw-text-opacity: 1;
  color: rgb(121 153 191 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-500:hover {
  --tw-text-opacity: 1;
  color: rgb(0 45 114 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: rgb(0 36 91 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-600:hover {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-200:hover {
  color: oklch(92.9% 0.013 255.508);
}
.hover\\:text-slate-300:hover {
  color: oklch(86.9% 0.022 252.894);
}
.hover\\:text-slate-400:hover {
  color: oklch(70.4% 0.04 256.788);
}
.hover\\:text-slate-500:hover {
  color: oklch(55.4% 0.046 257.417);
}
.hover\\:text-slate-600:hover {
  color: oklch(44.6% 0.043 257.281);
}
.hover\\:text-slate-700:hover {
  color: oklch(37.2% 0.044 257.287);
}
.hover\\:text-slate-800:hover {
  color: oklch(27.9% 0.041 260.031);
}
.hover\\:text-slate-900:hover {
  color: oklch(20.8% 0.042 265.755);
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-70:hover {
  opacity: 0.7;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_0_0_4px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.2\\)\\]:hover {
  --tw-shadow: 0 0 0 4px rgba(255,255,255,0.2);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_0_20px_\\#00ffff33\\]:hover {
  --tw-shadow: 0 0 20px #00ffff33;
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_0_20px_\\#00ffff88\\]:hover {
  --tw-shadow: 0 0 20px #00ffff88;
  --tw-shadow-colored: 0 0 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-blue-500\\/20:hover {
  --tw-shadow-color: rgb(59 130 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-500\\/25:hover {
  --tw-shadow-color: rgb(59 130 246 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-emerald-50:hover {
  --tw-shadow-color: #ecfdf5;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-50:hover {
  --tw-shadow-color: #eef2ff;
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-500\\/20:hover {
  --tw-shadow-color: rgb(99 102 241 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-2:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-indigo-400:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}
.focus\\:w-64:focus {
  width: 16rem;
}
.focus\\:border-b:focus {
  border-bottom-width: 1px;
}
.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500\\/50:focus {
  border-color: rgb(99 102 241 / 0.5);
}
.focus\\:border-indigo-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:bg-gray-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-gray-900:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-slate-50:focus {
  background-color: oklch(98.4% 0.003 247.858);
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-white\\/5:focus {
  background-color: rgb(255 255 255 / 0.05);
}
.focus\\:placeholder-slate-400:focus::placeholder {
  color: oklch(70.4% 0.04 256.788);
}
.focus\\:opacity-80:focus {
  opacity: 0.8;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}
.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500\\/10:focus {
  --tw-ring-color: rgb(59 130 246 / 0.1);
}
.focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.focus\\:ring-emerald-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-emerald-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-50:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 242 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500\\/10:focus {
  --tw-ring-color: rgb(99 102 241 / 0.1);
}
.focus\\:ring-indigo-500\\/20:focus {
  --tw-ring-color: rgb(99 102 241 / 0.2);
}
.focus\\:ring-indigo-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-primary-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 45 114 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-slate-100:focus {
  --tw-ring-color: oklch(96.8% 0.007 247.896);
}
.focus\\:ring-opacity-50:focus {
  --tw-ring-opacity: 0.5;
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-4:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-indigo-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-slate-900:focus-visible {
  --tw-ring-offset-color: oklch(20.8% 0.042 265.755);
}
.active\\:translate-y-0:active {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-90:active {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:cursor-grabbing:active {
  cursor: grabbing;
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:translate-y-0:disabled {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-slate-100:disabled {
  background-color: oklch(96.8% 0.007 247.896);
}
.disabled\\:bg-slate-200:disabled {
  background-color: oklch(92.9% 0.013 255.508);
}
.disabled\\:bg-slate-300:disabled {
  background-color: oklch(86.9% 0.022 252.894);
}
.disabled\\:bg-slate-400:disabled {
  background-color: oklch(70.4% 0.04 256.788);
}
.disabled\\:text-slate-400:disabled {
  color: oklch(70.4% 0.04 256.788);
}
.disabled\\:opacity-0:disabled {
  opacity: 0;
}
.disabled\\:opacity-20:disabled {
  opacity: 0.2;
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}
.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:hover\\:scale-100:hover:disabled {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}
.group[open] .group-open\\:rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:focus-within .group-focus-within\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.group:focus-within .group-focus-within\\:text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:inline {
  display: inline;
}
.group:hover .group-hover\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:border-indigo-400\\/50 {
  border-color: rgb(129 140 248 / 0.5);
}
.group:hover .group-hover\\:border-slate-300 {
  border-color: oklch(86.9% 0.022 252.894);
}
.group:hover .group-hover\\:border-slate-400 {
  border-color: oklch(70.4% 0.04 256.788);
}
.group:hover .group-hover\\:bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-indigo-100\\/50 {
  background-color: rgb(224 231 255 / 0.5);
}
.group:hover .group-hover\\:bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 230 240 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:from-purple-400 {
  --tw-gradient-from: #c084fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:to-indigo-400 {
  --tw-gradient-to: #818cf8 var(--tw-gradient-to-position);
}
.group:hover .group-hover\\:fill-white {
  fill: #fff;
}
.group:hover .group-hover\\:stroke-white {
  stroke: #fff;
}
.group\\/select:hover .group-hover\\/select\\:text-neutral-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-50 {
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(0 36 91 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-300 {
  color: oklch(86.9% 0.022 252.894);
}
.group:hover .group-hover\\:text-slate-600 {
  color: oklch(44.6% 0.043 257.281);
}
.group:hover .group-hover\\:text-slate-700 {
  color: oklch(37.2% 0.044 257.287);
}
.group:hover .group-hover\\:text-slate-900 {
  color: oklch(20.8% 0.042 265.755);
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-20 {
  opacity: 0.2;
}
.group:hover .group-hover\\:opacity-40 {
  opacity: 0.4;
}
.group:hover .group-hover\\:opacity-50 {
  opacity: 0.5;
}
.group:hover .group-hover\\:opacity-80 {
  opacity: 0.8;
}
.group:hover .group-hover\\:shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.group:hover .group-hover\\:ring-indigo-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.group:hover .group-hover\\:grayscale-0 {
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.group:hover .group-hover\\:duration-200 {
  transition-duration: 200ms;
}
.prose-headings\\:font-bold :is(:where(h1, h2, h3, h4, h5, h6, th):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  font-weight: 700;
}
.prose-headings\\:tracking-tight :is(:where(h1, h2, h3, h4, h5, h6, th):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  letter-spacing: -0.025em;
}
.prose-headings\\:text-slate-900 :is(:where(h1, h2, h3, h4, h5, h6, th):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  color: oklch(20.8% 0.042 265.755);
}
.prose-p\\:my-2 :is(:where(p):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.prose-p\\:leading-relaxed :is(:where(p):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  line-height: 1.625;
}
.prose-p\\:text-slate-600 :is(:where(p):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  color: oklch(44.6% 0.043 257.281);
}
.prose-p\\:text-slate-700 :is(:where(p):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  color: oklch(37.2% 0.044 257.287);
}
.prose-a\\:text-blue-600 :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.prose-a\\:text-indigo-600 :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.prose-a\\:text-primary-600 :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  --tw-text-opacity: 1;
  color: rgb(0 36 91 / var(--tw-text-opacity, 1));
}
.prose-a\\:no-underline :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  text-decoration-line: none;
}
.hover\\:prose-a\\:text-blue-500 :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))):hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.hover\\:prose-a\\:text-primary-700 :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))):hover {
  --tw-text-opacity: 1;
  color: rgb(0 27 68 / var(--tw-text-opacity, 1));
}
.hover\\:prose-a\\:underline :is(:where(a):not(:where([class~="not-prose"],[class~="not-prose"] *))):hover {
  text-decoration-line: underline;
}
.prose-code\\:rounded :is(:where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-radius: 0.25rem;
}
.prose-code\\:bg-blue-50 :is(:where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.prose-code\\:px-1 :is(:where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.prose-code\\:font-mono :is(:where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  font-family: JetBrains Mono, monospace;
}
.prose-code\\:text-sm :is(:where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.prose-code\\:text-blue-600 :is(:where(code):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.prose-pre\\:my-0 :is(:where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  margin-top: 0px;
  margin-bottom: 0px;
}
.prose-pre\\:border :is(:where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-width: 1px;
}
.prose-pre\\:border-slate-800 :is(:where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-color: oklch(27.9% 0.041 260.031);
}
.prose-pre\\:bg-\\[\\#0B0F19\\] :is(:where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  --tw-bg-opacity: 1;
  background-color: rgb(11 15 25 / var(--tw-bg-opacity, 1));
}
.prose-pre\\:bg-slate-800 :is(:where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  background-color: oklch(27.9% 0.041 260.031);
}
.prose-pre\\:text-slate-50 :is(:where(pre):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  color: oklch(98.4% 0.003 247.858);
}
.prose-img\\:rounded-xl :is(:where(img):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-radius: 0.75rem;
}
.prose-img\\:border :is(:where(img):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-width: 1px;
}
.prose-img\\:border-slate-200 :is(:where(img):not(:where([class~="not-prose"],[class~="not-prose"] *))) {
  border-color: oklch(92.9% 0.013 255.508);
}
.dark\\:block:is(.dark *) {
  display: block;
}
.dark\\:hidden:is(.dark *) {
  display: none;
}
.dark\\:border-blue-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.dark\\:border-blue-500\\/20:is(.dark *) {
  border-color: rgb(59 130 246 / 0.2);
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.dark\\:border-indigo-900\\/50:is(.dark *) {
  border-color: rgb(49 46 129 / 0.5);
}
.dark\\:border-neutral-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity, 1));
}
.dark\\:border-primary-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 27 68 / var(--tw-border-opacity, 1));
}
.dark\\:border-primary-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 18 45 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700:is(.dark *) {
  border-color: oklch(37.2% 0.044 257.287);
}
.dark\\:border-slate-800:is(.dark *) {
  border-color: oklch(27.9% 0.041 260.031);
}
.dark\\:border-white\\/10:is(.dark *) {
  border-color: rgb(255 255 255 / 0.1);
}
.dark\\:bg-black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-400:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-900\\/10:is(.dark *) {
  background-color: rgb(30 58 138 / 0.1);
}
.dark\\:bg-gray-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}
.dark\\:bg-neutral-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-neutral-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-neutral-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 36 91 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-900\\/20:is(.dark *) {
  background-color: rgb(0 9 23 / 0.2);
}
.dark\\:bg-primary-900\\/30:is(.dark *) {
  background-color: rgb(0 9 23 / 0.3);
}
.dark\\:bg-sky-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-600:is(.dark *) {
  background-color: oklch(44.6% 0.043 257.281);
}
.dark\\:bg-slate-700:is(.dark *) {
  background-color: oklch(37.2% 0.044 257.287);
}
.dark\\:bg-slate-800:is(.dark *) {
  background-color: oklch(27.9% 0.041 260.031);
}
.dark\\:bg-slate-900:is(.dark *) {
  background-color: oklch(20.8% 0.042 265.755);
}
.dark\\:bg-slate-950:is(.dark *) {
  background-color: oklch(12.9% 0.042 264.695);
}
.dark\\:bg-white:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.dark\\:from-slate-800:is(.dark *) {
  --tw-gradient-from: oklch(27.9% 0.041 260.031) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:to-slate-900:is(.dark *) {
  --tw-gradient-to: oklch(20.8% 0.042 265.755) var(--tw-gradient-to-position);
}
.dark\\:text-black:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.dark\\:text-neutral-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.dark\\:text-neutral-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.dark\\:text-neutral-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(154 179 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(121 153 191 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-200:is(.dark *) {
  color: oklch(92.9% 0.013 255.508);
}
.dark\\:text-slate-300:is(.dark *) {
  color: oklch(86.9% 0.022 252.894);
}
.dark\\:text-slate-400:is(.dark *) {
  color: oklch(70.4% 0.04 256.788);
}
.dark\\:text-slate-500:is(.dark *) {
  color: oklch(55.4% 0.046 257.417);
}
.dark\\:text-slate-600:is(.dark *) {
  color: oklch(44.6% 0.043 257.281);
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:opacity-0:is(.dark *) {
  opacity: 0;
}
.dark\\:opacity-100:is(.dark *) {
  opacity: 1;
}
.dark\\:hover\\:border-blue-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-primary-700:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 27 68 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-neutral-200:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-neutral-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-primary-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 45 114 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-primary-900\\/20:hover:is(.dark *) {
  background-color: rgb(0 9 23 / 0.2);
}
.dark\\:hover\\:bg-sky-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *) {
  background-color: oklch(37.2% 0.044 257.287);
}
.dark\\:hover\\:bg-slate-800:hover:is(.dark *) {
  background-color: oklch(27.9% 0.041 260.031);
}
.dark\\:hover\\:bg-slate-900:hover:is(.dark *) {
  background-color: oklch(20.8% 0.042 265.755);
}
.dark\\:hover\\:text-neutral-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-primary-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(121 153 191 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-200:hover:is(.dark *) {
  color: oklch(92.9% 0.013 255.508);
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:bg-neutral-200:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.dark\\:focus\\:bg-neutral-700:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.dark\\:focus\\:text-neutral-200:focus:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:ring-green-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 101 52 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-sky-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(7 89 133 / var(--tw-ring-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-primary-900\\/40:is(.dark *) {
  background-color: rgb(0 9 23 / 0.4);
}
.group:hover .dark\\:group-hover\\:text-primary-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(121 153 191 / var(--tw-text-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-slate-200:is(.dark *) {
  color: oklch(92.9% 0.013 255.508);
}
.dark\\:prose-headings\\:text-white :is(:where(h1, h2, h3, h4, h5, h6, th):not(:where([class~="not-prose"],[class~="not-prose"] *))):is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media not all and (min-width: 1024px) {
  .max-lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .max-lg\\:max-w-xl {
    max-width: 36rem;
  }
}
@media (min-width: 640px) {
  .sm\\:mt-0 {
    margin-top: 0px;
  }
  .sm\\:block {
    display: block;
  }
  .sm\\:inline {
    display: inline;
  }
  .sm\\:flex {
    display: flex;
  }
  .sm\\:table-cell {
    display: table-cell;
  }
  .sm\\:hidden {
    display: none;
  }
  .sm\\:h-16 {
    height: 4rem;
  }
  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }
  .sm\\:w-16 {
    width: 4rem;
  }
  .sm\\:w-auto {
    width: auto;
  }
  .sm\\:max-w-full {
    max-width: 100%;
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:items-end {
    align-items: flex-end;
  }
  .sm\\:items-center {
    align-items: center;
  }
  .sm\\:justify-end {
    justify-content: flex-end;
  }
  .sm\\:justify-center {
    justify-content: center;
  }
  .sm\\:gap-12 {
    gap: 3rem;
  }
  .sm\\:gap-4 {
    gap: 1rem;
  }
  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }
  .sm\\:border-t-0 {
    border-top-width: 0px;
  }
  .sm\\:p-12 {
    padding: 3rem;
  }
  .sm\\:p-4 {
    padding: 1rem;
  }
  .sm\\:p-6 {
    padding: 1.5rem;
  }
  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .sm\\:pt-0 {
    padding-top: 0px;
  }
  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 768px) {
  .md\\:static {
    position: static;
  }
  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .md\\:row-span-2 {
    grid-row: span 2 / span 2;
  }
  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }
  .md\\:mb-0 {
    margin-bottom: 0px;
  }
  .md\\:mb-12 {
    margin-bottom: 3rem;
  }
  .md\\:mb-24 {
    margin-bottom: 6rem;
  }
  .md\\:mb-32 {
    margin-bottom: 8rem;
  }
  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .md\\:mb-8 {
    margin-bottom: 2rem;
  }
  .md\\:ml-64 {
    margin-left: 16rem;
  }
  .md\\:mr-4 {
    margin-right: 1rem;
  }
  .md\\:mt-0 {
    margin-top: 0px;
  }
  .md\\:block {
    display: block;
  }
  .md\\:inline {
    display: inline;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:table-cell {
    display: table-cell;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:aspect-\\[21\\/9\\] {
    aspect-ratio: 21/9;
  }
  .md\\:aspect-\\[4\\/3\\] {
    aspect-ratio: 4/3;
  }
  .md\\:h-10 {
    height: 2.5rem;
  }
  .md\\:h-12 {
    height: 3rem;
  }
  .md\\:h-16 {
    height: 4rem;
  }
  .md\\:h-20 {
    height: 5rem;
  }
  .md\\:h-28 {
    height: 7rem;
  }
  .md\\:h-56 {
    height: 14rem;
  }
  .md\\:h-\\[600px\\] {
    height: 600px;
  }
  .md\\:h-\\[800px\\] {
    height: 800px;
  }
  .md\\:h-auto {
    height: auto;
  }
  .md\\:min-h-\\[60vh\\] {
    min-height: 60vh;
  }
  .md\\:w-1\\/2 {
    width: 50%;
  }
  .md\\:w-1\\/3 {
    width: 33.333333%;
  }
  .md\\:w-10 {
    width: 2.5rem;
  }
  .md\\:w-12 {
    width: 3rem;
  }
  .md\\:w-16 {
    width: 4rem;
  }
  .md\\:w-2\\/3 {
    width: 66.666667%;
  }
  .md\\:w-20 {
    width: 5rem;
  }
  .md\\:w-24 {
    width: 6rem;
  }
  .md\\:w-28 {
    width: 7rem;
  }
  .md\\:w-32 {
    width: 8rem;
  }
  .md\\:w-48 {
    width: 12rem;
  }
  .md\\:w-64 {
    width: 16rem;
  }
  .md\\:w-80 {
    width: 20rem;
  }
  .md\\:w-96 {
    width: 24rem;
  }
  .md\\:w-\\[480px\\] {
    width: 480px;
  }
  .md\\:w-\\[600px\\] {
    width: 600px;
  }
  .md\\:w-\\[60vw\\] {
    width: 60vw;
  }
  .md\\:w-\\[800px\\] {
    width: 800px;
  }
  .md\\:w-auto {
    width: auto;
  }
  .md\\:min-w-full {
    min-width: 100%;
  }
  .md\\:max-w-\\[250px\\] {
    max-width: 250px;
  }
  .md\\:max-w-\\[640px\\] {
    max-width: 640px;
  }
  .md\\:max-w-\\[720px\\] {
    max-width: 720px;
  }
  .md\\:max-w-lg {
    max-width: 32rem;
  }
  .md\\:flex-none {
    flex: none;
  }
  .md\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .md\\:flex-row {
    flex-direction: row;
  }
  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }
  .md\\:flex-col {
    flex-direction: column;
  }
  .md\\:items-start {
    align-items: flex-start;
  }
  .md\\:items-end {
    align-items: flex-end;
  }
  .md\\:items-center {
    align-items: center;
  }
  .md\\:justify-start {
    justify-content: flex-start;
  }
  .md\\:justify-end {
    justify-content: flex-end;
  }
  .md\\:gap-12 {
    gap: 3rem;
  }
  .md\\:gap-3 {
    gap: 0.75rem;
  }
  .md\\:gap-4 {
    gap: 1rem;
  }
  .md\\:gap-6 {
    gap: 1.5rem;
  }
  .md\\:space-x-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }
  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }
  .md\\:border-l {
    border-left-width: 1px;
  }
  .md\\:border-r {
    border-right-width: 1px;
  }
  .md\\:p-0 {
    padding: 0px;
  }
  .md\\:p-10 {
    padding: 2.5rem;
  }
  .md\\:p-12 {
    padding: 3rem;
  }
  .md\\:p-16 {
    padding: 4rem;
  }
  .md\\:p-6 {
    padding: 1.5rem;
  }
  .md\\:p-8 {
    padding: 2rem;
  }
  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .md\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .md\\:pl-2 {
    padding-left: 0.5rem;
  }
  .md\\:pt-0 {
    padding-top: 0px;
  }
  .md\\:pt-10 {
    padding-top: 2.5rem;
  }
  .md\\:pt-12 {
    padding-top: 3rem;
  }
  .md\\:text-left {
    text-align: left;
  }
  .md\\:text-right {
    text-align: right;
  }
  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
  .md\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }
  .md\\:text-8xl {
    font-size: 6rem;
    line-height: 1;
  }
  .md\\:text-\\[9px\\] {
    font-size: 9px;
  }
  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .md\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .md\\:blur-\\[100px\\] {
    --tw-blur: blur(100px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .md\\:blur-\\[120px\\] {
    --tw-blur: blur(120px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
}
@media (min-width: 1024px) {
  .lg\\:sticky {
    position: sticky;
  }
  .lg\\:bottom-0 {
    bottom: 0px;
  }
  .lg\\:end-auto {
    inset-inline-end: auto;
  }
  .lg\\:left-20 {
    left: 5rem;
  }
  .lg\\:right-4 {
    right: 1rem;
  }
  .lg\\:top-24 {
    top: 6rem;
  }
  .lg\\:top-32 {
    top: 8rem;
  }
  .lg\\:order-1 {
    order: 1;
  }
  .lg\\:order-2 {
    order: 2;
  }
  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }
  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }
  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }
  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }
  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }
  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }
  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }
  .lg\\:ml-64 {
    margin-left: 16rem;
  }
  .lg\\:mr-5 {
    margin-right: 1.25rem;
  }
  .lg\\:mt-0 {
    margin-top: 0px;
  }
  .lg\\:mt-12 {
    margin-top: 3rem;
  }
  .lg\\:mt-4 {
    margin-top: 1rem;
  }
  .lg\\:block {
    display: block;
  }
  .lg\\:inline {
    display: inline;
  }
  .lg\\:flex {
    display: flex;
  }
  .lg\\:grid {
    display: grid;
  }
  .lg\\:hidden {
    display: none;
  }
  .lg\\:h-10 {
    height: 2.5rem;
  }
  .lg\\:h-12 {
    height: 3rem;
  }
  .lg\\:h-24 {
    height: 6rem;
  }
  .lg\\:h-32 {
    height: 8rem;
  }
  .lg\\:h-40 {
    height: 10rem;
  }
  .lg\\:h-64 {
    height: 16rem;
  }
  .lg\\:h-8 {
    height: 2rem;
  }
  .lg\\:h-\\[500px\\] {
    height: 500px;
  }
  .lg\\:h-\\[600px\\] {
    height: 600px;
  }
  .lg\\:h-full {
    height: 100%;
  }
  .lg\\:min-h-full {
    min-height: 100%;
  }
  .lg\\:w-0 {
    width: 0px;
  }
  .lg\\:w-1\\/2 {
    width: 50%;
  }
  .lg\\:w-12 {
    width: 3rem;
  }
  .lg\\:w-2\\/5 {
    width: 40%;
  }
  .lg\\:w-20 {
    width: 5rem;
  }
  .lg\\:w-24 {
    width: 6rem;
  }
  .lg\\:w-3\\/5 {
    width: 60%;
  }
  .lg\\:w-32 {
    width: 8rem;
  }
  .lg\\:w-40 {
    width: 10rem;
  }
  .lg\\:w-52 {
    width: 13rem;
  }
  .lg\\:w-64 {
    width: 16rem;
  }
  .lg\\:w-96 {
    width: 24rem;
  }
  .lg\\:w-auto {
    width: auto;
  }
  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-row {
    flex-direction: row;
  }
  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }
  .lg\\:items-center {
    align-items: center;
  }
  .lg\\:justify-start {
    justify-content: flex-start;
  }
  .lg\\:justify-center {
    justify-content: center;
  }
  .lg\\:justify-between {
    justify-content: space-between;
  }
  .lg\\:gap-12 {
    gap: 3rem;
  }
  .lg\\:gap-16 {
    gap: 4rem;
  }
  .lg\\:gap-20 {
    gap: 5rem;
  }
  .lg\\:gap-24 {
    gap: 6rem;
  }
  .lg\\:gap-x-12 {
    column-gap: 3rem;
  }
  .lg\\:gap-y-0 {
    row-gap: 0px;
  }
  .lg\\:p-10 {
    padding: 2.5rem;
  }
  .lg\\:p-12 {
    padding: 3rem;
  }
  .lg\\:p-14 {
    padding: 3.5rem;
  }
  .lg\\:p-16 {
    padding: 4rem;
  }
  .lg\\:p-20 {
    padding: 5rem;
  }
  .lg\\:p-24 {
    padding: 6rem;
  }
  .lg\\:p-8 {
    padding: 2rem;
  }
  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }
  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .lg\\:pl-20 {
    padding-left: 5rem;
  }
  .lg\\:pl-64 {
    padding-left: 16rem;
  }
  .lg\\:pr-12 {
    padding-right: 3rem;
  }
  .lg\\:pt-4 {
    padding-top: 1rem;
  }
  .lg\\:text-left {
    text-align: left;
  }
  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }
  .lg\\:text-8xl {
    font-size: 6rem;
    line-height: 1;
  }
  .lg\\:text-\\[100px\\] {
    font-size: 100px;
  }
  .lg\\:text-\\[28px\\] {
    font-size: 28px;
  }
  .lg\\:text-\\[50px\\] {
    font-size: 50px;
  }
  .lg\\:opacity-0 {
    opacity: 0;
  }
}
@media (min-width: 1280px) {
  .xl\\:block {
    display: block;
  }
  .xl\\:inline {
    display: inline;
  }
  .xl\\:flex {
    display: flex;
  }
  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.dark\\:\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-neutral-500:is(.dark *)::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-gray-100::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.dark\\:\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-neutral-700:is(.dark *)::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {
  width: 0.5rem;
}
.\\[\\&_\\*\\]\\:transition-all * {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\[\\&_\\*\\]\\:duration-150 * {
  transition-duration: 150ms;
}
.\\[\\&_\\*\\]\\:ease-in * {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.\\[\\&_text\\]\\:hidden text {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd,kEAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,sCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,2BAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,iBAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB;AAAoB;AAApB;EAAA,4BAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,kBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA,gCAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,kBAAoB;EAApB,6BAAoB;EAApB,kCAAoB;EAApB,wDAAoB;EAApB,oCAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,oBAAoB;EAApB,0BAAoB;EAApB,sFAAoB;EAApB,kBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,2BAAoB;EAApB,wBAAoB;EAApB;AAAoB;AAApB;EAAA,2BAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,+BAAoB;EAApB,wCAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,uBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,eAAoB;EAApB,gBAAoB;EAApB,UAAoB;EAApB,oBAAoB;EAApB,cAAoB;EAApB,kBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,gBAAoB;EAApB,sBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,wBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB,kBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA,2CAAoB;EAApB,6CAAoB;EAApB,0CAAoB;EAApB,0CAAoB;EAApB,yCAAoB;EAApB,+CAAoB;EAApB,6CAAoB;EAApB,yCAAoB;EAApB,2CAAoB;EAApB,oDAAoB;EAApB,+CAAoB;EAApB,wCAAoB;EAApB,sFAAoB;EAApB,yCAAoB;EAApB,+CAAoB;EAApB,6CAAoB;EAApB,gDAAoB;EAApB,iDAAoB;EAApB,iDAAoB;EAApB,gCAAoB;EAApB,kDAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,sDAAoB;EAApB,oDAAoB;EAApB,gDAAoB;EAApB,oDAAoB;EAApB,2DAAoB;EAApB,sDAAoB;EAApB,2BAAoB;EAApB,qDAAoB;EAApB,4BAAoB;EAApB,qDAAoB;EAApB,0CAAoB;EAApB,uDAAoB;EAApB,wDAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,uBAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,aAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,+BAAoB;EAApB,2BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,iBAAoB;EAApB,eAAoB;EAApB,kBAAoB;EAApB,uBAAoB;EAApB,gBAAoB;EAApB,yBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB,0BAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,0BAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,mBAAoB;EAApB,0BAAoB;EAApB,sBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,uBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,2CAAoB;EAApB,+CAAoB;EAApB,2CAAoB;EAApB,4CAAoB;EAApB,2CAAoB;EAApB,+CAAoB;EAApB,8CAAoB;EAApB,yCAAoB;EAApB,6CAAoB;EAApB,oDAAoB;EAApB,+CAAoB;EAApB,0CAAoB;EAApB,wFAAoB;EAApB,2CAAoB;EAApB,+CAAoB;EAApB,6CAAoB;EAApB,iDAAoB;EAApB,iDAAoB;EAApB,kDAAoB;EAApB,gCAAoB;EAApB,iDAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,qDAAoB;EAApB,qDAAoB;EAApB,gDAAoB;EAApB,oDAAoB;EAApB,2DAAoB;EAApB,qDAAoB;EAApB,2BAAoB;EAApB,qDAAoB;EAApB,4BAAoB;EAApB,sDAAoB;EAApB,0CAAoB;EAApB,wDAAoB;EAApB;AAAoB;AAApB;EAAA,2CAAoB;EAApB;AAAoB;AAApB;EAAA,4CAAoB;EAApB;AAAoB;AAApB;EAAA,4CAAoB;EAApB,oDAAoB;EAApB,4CAAoB;EAApB,8CAAoB;EAApB,4CAAoB;EAApB,oDAAoB;EAApB,kDAAoB;EAApB,wCAAoB;EAApB,gDAAoB;EAApB,8DAAoB;EAApB,oDAAoB;EAApB,0CAAoB;EAApB,0DAAoB;EAApB,4CAAoB;EAApB,oDAAoB;EAApB,gDAAoB;EAApB,wDAAoB;EAApB;AAAoB;;EAQlB,0BAA0B;EAExB;EAAA,kBAA0E;EAA1E,gBAA0E;EAA1E,oBAA0E;EAA1E;AAA0E;EAA1E;EAAA,oBAA0E;EAA1E;AAA0E;;EAI1E;EAAA,kBAAmE;EAAnE,gBAAmE;EAAnE,iBAAmE;EAAnE;AAAmE;;EAAnE;EAAA,oBAAmE;EAAnE;AAAmE;;EAInE;EAAA;AAAyC;;EAAzC;EAAA;AAAyC;;EAG3C,uBAAuB;EAErB;EAAA,iBAAgR;EAAhR,kBAAgR;EAAhR,aAAgR;EAAhR,YAAgR;EAAhR,eAAgR;EAAhR,mBAAgR;EAAhR,uBAAgR;EAAhR,qBAAgR;EAAhR,iBAAgR;EAAhR,wCAAgR;EAAhR,qBAAgR;EAAhR,wBAAgR;EAAhR,qBAAgR;EAAhR,sBAAgR;EAAhR,gBAAgR;EAAhR,iCAAgR;EAAhR,0CAAgR;EAAhR,uDAAgR;EAAhR,uGAAgR;EAAhR,wBAAgR;EAAhR,wDAAgR;EAAhR;AAAgR;EAAhR;EAAA;AAAgR;EAAhR;EAAA,wCAAgR;EAAhR,oBAAgR;EAAhR;AAAgR;EAAhR;EAAA;AAAgR;EAAhR;EAAA;IAAA,gBAAgR;IAAhR;EAAgR;AAAA;;EAIhR;EAAA,aAA0L;EAA1L,eAA0L;EAA1L,cAA0L;EAA1L,eAA0L;EAA1L,mBAA0L;EAA1L,uBAA0L;EAA1L,qBAA0L;EAA1L,iBAA0L;EAA1L,sBAA0L;EAA1L,wDAA0L;EAA1L,oBAA0L;EAA1L,+CAA0L;EAA1L,wBAA0L;EAA1L,wDAA0L;EAA1L;AAA0L;;EAA1L;EAAA,kBAA0L;EAA1L,wDAA0L;EAA1L,oBAA0L;EAA1L;AAA0L;;EAI1L;EAAA,aAA6J;EAA7J,eAA6J;EAA7J,mBAA6J;EAA7J,WAA6J;EAA7J,mBAA6J;EAA7J,oBAA6J;EAA7J,gBAA6J;EAA7J,oBAA6J;EAA7J;AAA6J;;EAA7J;EAAA,oBAA6J;EAA7J;AAA6J;;EAA7J;EAAA,oBAA6J;EAA7J;AAA6J;;EAA7J;EAAA,oBAA6J;EAA7J;AAA6J;;EAG/J,8BAA8B;EAE5B;EAAA,4CAA0C;EAA1C,iBAA0C;EAA1C;AAA0C;EAA1C;EAAA;AAA0C;;EAI1C;EAAA,qBAAoG;EAApG,aAAoG;EAApG,aAAoG;EAApG,WAAoG;EAApG,mBAAoG;EAApG,gBAAoG;EAApG,mBAAoG;EAApG;AAAoG;;EAApG;EAAA;AAAoG;;EAIpG;EAAA,YAAyF;EAAzF,WAAyF;EAAzF,iBAAyF;EAAzF,8BAAyF;EAAzF,wDAAyF;EAAzF;AAAyF;;EAAzF;EAAA,kBAAyF;EAAzF,kBAAyF;EAAzF;AAAyF;;EAG3F;IACE,iDAAiD;EACnD;;EAEA;;gDAE8C;;EAE9C;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,eAA8C;IAA9C,mBAA8C;IAA9C,kBAA8C;IAA9C,oBAA8C;IAA9C,gDAA8C;EAChD;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,wBAAwB;EAC1B;;EAMA,oBAAoB;EACD;EAAA,gBAAqE;EAArE,mBAAqE;EAArE,kBAAqE;EAArE,mBAAqE;EAArE,gBAAqE;EAArE,iBAAqE;EAArE;AAAqE;EACrE;EAAA,kBAAgE;EAAhE,sBAAgE;EAAhE,mBAAgE;EAAhE,oBAAgE;EAAhE,gBAAgE;EAAhE,iBAAgE;EAAhE;AAAgE;EAChE;EAAA,mBAAsD;EAAtD,qBAAsD;EAAtD,iBAAsD;EAAtD,iBAAsD;EAAtD,gBAAsD;EAAtD;AAAsD;EACtD;EAAA,gBAAqD;EAArD,qBAAqD;EAArD,kBAAqD;EAArD,oBAAqD;EAArD,gBAAqD;EAArD;AAAqD;EACtD;EAAA,mBAAqB;EAArB,sBAAqB;EAArB;AAAqB;;EAEvC,sBAAsB;EACtB;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB,cAAc;IACd,kBAA+D;IAA/D,qBAA+D;IAA/D,cAA+D;IAA/D,+BAA+D;IAA/D,kCAA+D;IAA/D,iBAA+D;IAA/D,oBAA+D;IAA/D,mBAA+D;IAA/D,oBAA+D;IAA/D,kBAA+D;IAA/D,0CAA+D;IAA/D,uDAA+D;IAA/D,uGAA+D;IAC/D,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,oBAAoB;EACtB;;EAEA,0BAA0B;EAExB;EAAA,kBAAuE;EAAvE,sBAAuE;EAAvE,iBAAuE;EAAvE,yBAAuE;EAAvE,eAAuE;EAAvE,wBAAuE;EAAvE,wDAAuE;EAAvE;AAAuE;;EAIvE;EAAA,sBAAwC;EAAxC,4DAAwC;EAAxC;AAAwC;;EAG1C,kBAAkB;EACC;EAAA,mBAAoC;EAApC,sBAAoC;EAApC;AAAoC;EAApC;EAAA,uBAAoC;EAApC,+DAAoC;EAApC;AAAoC;EAApC;EAAA;AAAoC;EACpC;EAAA,mBAAuC;EAAvC,sBAAuC;EAAvC;AAAuC;EAAvC;EAAA,uBAAuC;EAAvC,+DAAuC;EAAvC;AAAuC;EAAvC;EAAA;AAAuC;EACtC;EAAA,gBAA6F;EAA7F,mBAA6F;EAA7F,gBAA6F;EAA7F,qBAA6F;EAA7F,iBAA6F;EAA7F,wCAA6F;EAA7F,4CAA6F;EAA7F,aAA6F;EAA7F;AAA6F;EAC5F;EAAA,sBAAiG;EAAjG,iBAAiG;EAAjG,wCAAiG;EAAjG,4CAAiG;EAAjG,sBAAiG;EAAjG,uBAAiG;EAAjG,qBAAiG;EAAjG,wBAAiG;EAAjG,sCAAiG;EAAjG,mBAAiG;EAAjG,oBAAiG;EAAjG,oBAAiG;EAAjG;AAAiG;EACpG;EAAA,eAA0G;EAA1G,oBAA0G;EAA1G,iDAA0G;EAA1G,+BAA0G;EAA1G,8BAA0G;EAA1G,wBAA0G;EAA1G,wDAA0G;EAA1G;AAA0G;EAA1G;EAAA;AAA0G;;EAE5H,mBAAmB;EACnB;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,iDAAiD,gCAAgC,EAAE;;EAEnF;IACE,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,yBAAyB,oCAAoC,EAAE,WAAW,EAAE;;EAE5E,yBAAyB;EAEvB;EAAA,oBAAsH;EAAtH,kBAAsH;EAAtH,WAAsH;EAAtH,YAAsH;EAAtH,QAAsH;EAAtH,WAAsH;EAAtH,cAAsH;EAAtH,kBAAsH;EAAtH,2DAAsH;EAAtH,UAAsH;EAAtH,4BAAsH;EAAtH,wDAAsH;EAAtH;AAAsH;;EAIzE;;EAAA,oBAAsC;EAAtC;AAAsC;AA5JvF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,oFAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;8CAE8C,EA4J5C,kCAAkC;;AAEpC;;8CAE8C;;AAE9C,2CAA2C;AAC3C,mEAAmE;AACnE;;;EAGE,yBAAyB,EAAE,sDAAsD;EACjF,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;;;;;;EAME,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA,yCAAyC;AACzC,kEAAkE;AAMhE;;;;;EAAA,kBAAuC;EAAvC,qBAAuC;EAAvC,wBAAuC;EAAvC,wDAAuC;EAAvC,0BAAuC;EACvC,WAAW;EACX,WAAW;EACX,kBAAkB,EAAE,6BAA6B;AAHV;;AAMzC,4DAA4D;AAC5D,wEAAwE;AACxE;;;EAGE,qBAAqB,EAAE,uDAAuD;EAC9E,4BAA4B,EAAE,eAAe,EAC7C,qBAAuF,EAAvF,iBAAuF,EAAvF,oBAAuF,EAAvF,wCAAuF,EAAvF,4CAAuF,EAAvF,oBAAuF,EAAvF,eAAuF;AACzF;;AAEA;;;IAGI,qBAAqB;IACrB,kBAA4I;IAA5I,cAA4I;IAA5I,aAA4I;IAA5I,yBAA4I;YAA5I,iBAA4I;IAA5I,sBAA4I;IAA5I,4CAA4I;IAA5I,sBAA4I;IAA5I,uBAA4I;IAA5I,qBAA4I;IAA5I,wBAA4I;IAA5I,cAA4I;IAA5I,gBAA4I;IAA5I,yBAA4I;IAA5I,sBAA4I;IAA5I,iCAA4I;AAChJ;;AAEA,uDAAuD;;AAEvD,gDAAgD;AAChD;;;;EAIE,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;;;EAGE,4BAA4B;EAC5B,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,qBAA+D;EAA/D,iBAA+D;EAA/D,sBAA+D;EAA/D,4DAA+D;EAA/D,wCAA+D;EAA/D,gBAA+D;AACjE;;AAEA,uDAAuD;AACvD,gDAAgD;AAChD;;;EAGE,qBAAqB;EACrB,YAAY;EACZ,mBAAgB;EAAhB,mBAAgB;AAClB;;AAEA,4BAA4B;AAC5B,uCAAuC,oBAAoB,EAAE;;AAE7D,wDAAwD;AACxD;;EAEE,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE,kBAAkB,EAAE,SAAS;AACxE;;AAEA,4BAA4B,mBAAmB,EAAE,8BAA8B,EAAE;AACjF,yBAAyB,mBAAmB,EAAE,8BAA8B,EAAE;;AAE9E,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uCAAuC;;AAEvC,oBAAoB;AACpB;EACE,cAAc;EACd,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;;EAEE,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,sBAAsB,EAAE,qCAAqC;EAC7D,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD,8EAA8E;AAC9E;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAuF;EAAvF,iBAAuF;EAAvF,oBAAuF;EAAvF,wCAAuF;EAAvF,4CAAuF;EAAvF,oBAAuF;EAAvF,eAAuF;EACvF,kBAAkB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAA4I;IAA5I,cAA4I;IAA5I,aAA4I;IAA5I,yBAA4I;YAA5I,iBAA4I;IAA5I,sBAA4I;IAA5I,4CAA4I;IAA5I,sBAA4I;IAA5I,uBAA4I;IAA5I,qBAA4I;IAA5I,wBAA4I;IAA5I,cAA4I;IAA5I,gBAA4I;IAA5I,yBAA4I;IAA5I,sBAA4I;IAA5I,iCAA4I;AAChJ;;;AAGA,kCAAkC;AAClC;EACE,0CAA0C;EAC1C;;;;;GAKC;EACD,4BAA4B;EAC5B,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B,EAAE,kCAAkC;AACpE;;AAEA;;;EAGE,wBAAmB;EAAnB,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,iDAAiD;AACnD;;AAEA;;8CAE8C;AAC9C,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;;CAGC;AACD;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;;;AAGA,oCAAoC;AACpC,mBAAmB,oCAAoC,EAAE;AACzD,oBAAoB,qCAAqC,EAAE;AAC3D,sBAAsB,uCAAuC,EAAE;AAC/D,mBAAmB,oCAAoC,EAAE;AACzD,eAAe,gEAAgE,EAAE;;AAEjF;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,iCAAiC,EAAE;AAC1C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,iCAAiC,EAAE,wBAAwB,EAAE;AACpE;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,iCAAiC,EAAE,wBAAwB,EAAE;AACpE;AACA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,KAAK,iCAAiC,EAAE,mBAAmB,EAAE;AAC/D;AACA;EACE,KAAK,UAAU,EAAE,qBAAqB,EAAE;EACxC,MAAM,sBAAsB,EAAE;EAC9B,OAAO,iCAAiC,EAAE,mBAAmB,EAAE;AACjE;;AAEA,WAAW,oBAAoB,EAAE;AACjC,aAAa,sBAAsB,EAAE;AACrC,cAAc,uBAAuB,EAAE;AACvC,cAAc,uBAAuB,EAAE;AACvC,cAAc,uBAAuB,EAAE;AACvC,cAAc,uBAAuB,EAAE;AACvC,cAAc,uBAAuB,EAAE;AAzbvC;EAAA,4CAybwC;EAzbxC,oDAybwC;EAzbxC,4CAybwC;EAzbxC,8CAybwC;EAzbxC,4CAybwC;EAzbxC,oDAybwC;EAzbxC,kDAybwC;EAzbxC,wCAybwC;EAzbxC,gDAybwC;EAzbxC,8DAybwC;EAzbxC,oDAybwC;EAzbxC,0CAybwC;EAzbxC,0DAybwC;EAzbxC,4CAybwC;EAzbxC,oDAybwC;EAzbxC,gDAybwC;EAzbxC,wDAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;IAAA,eAybwC;IAzbxC,iBAybwC;EAAA;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC,gBAybwC;IAzbxC,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC,aAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,gBAybwC;IAzbxC,eAybwC;IAzbxC,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC,iBAybwC;IAzbxC,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,aAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC,wBAybwC;IAzbxC,qBAybwC;IAzbxC,2BAybwC;IAzbxC,wBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC,sBAybwC;IAzbxC,uBAybwC;IAzbxC,0BAybwC;IAzbxC,uBAybwC;IAzbxC,wBAybwC;IAzbxC,+BAybwC;IAzbxC,2BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC,qBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC,qBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,+BAybwC;IAzbxC,2BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,wBAybwC;IAzbxC,+BAybwC;IAzbxC,2BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,aAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC,sBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;AAAA;AAzbxC;EAAA;IAAA,mBAybwC;IAzbxC,sBAybwC;EAAA;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,sBAybwC;IAzbxC,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,aAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,uBAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,uBAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,aAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,wBAybwC;IAzbxC,wBAybwC;IAzbxC,+BAybwC;IAzbxC,2BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,iBAybwC;IAzbxC,eAybwC;IAzbxC,kBAybwC;IAzbxC,uBAybwC;IAzbxC,gBAybwC;IAzbxC,yBAybwC;IAzbxC,mBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,0BAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,0BAybwC;IAzbxC,sBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,mBAybwC;IAzbxC,0BAybwC;IAzbxC,sBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,aAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC,gBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;AAAA;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,qBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,0BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,4BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,2BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,0BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,0BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,iBAybwC;EAzbxC,iBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,iBAybwC;EAzbxC,iBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,gDAybwC;EAzbxC,6DAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,4CAybwC;EAzbxC,qDAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,+BAybwC;EAzbxC,oDAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,+BAybwC;EAzbxC,oDAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,+EAybwC;EAzbxC,mGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,6EAybwC;EAzbxC,iGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,0CAybwC;EAzbxC,uDAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,gFAybwC;EAzbxC,oGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,wCAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,yCAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,0BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,0BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,wCAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,8BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,8BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,qBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,gBAybwC;EAzbxC,gBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,iBAybwC;EAzbxC,iBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,qBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC,8BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,eAybwC;EAzbxC,eAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,qBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,yBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,mBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,eAybwC;EAzbxC,eAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,iBAybwC;EAzbxC,iBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,eAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,4DAybwC;EAzbxC,qEAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,6EAybwC;EAzbxC,iGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,2GAybwC;EAzbxC,yGAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,4BAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,qBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,mBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,eAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,+EAybwC;EAzbxC,qEAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,sBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,oBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;AAAA;AAzbxC;EAAA;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,sDAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,qBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;AAAA;AAzbxC;EAAA;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,gBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,qBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,sDAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,uBAybwC;IAzbxC,8DAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,qBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,mBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,mBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,mBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,sBAybwC;IAzbxC;EAybwC;AAAA;AAzbxC;EAAA;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,gBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,qBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,oBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,mBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,mBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,kBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,iBAybwC;IAzbxC;EAybwC;EAzbxC;IAAA,eAybwC;IAzbxC;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;AAAA;AAzbxC;EAAA;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;EAzbxC;IAAA;EAybwC;AAAA;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA,kBAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA,wBAybwC;EAzbxC,wDAybwC;EAzbxC;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC;AAzbxC;EAAA;AAybwC","sourcesContent":["/* src/index.css */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* =========================================\n   COMPONENT LAYER (Tailwind Managed)\n   ========================================= */\n@layer components {\n\n  /* --- 1. TYPOGRAPHY --- */\n  .heading-section {\n    @apply text-4xl font-bold leading-[3.25rem] text-slate-900 dark:text-white;\n  }\n\n  .subheading-card {\n    @apply text-xl font-medium leading-8 text-slate-900 dark:text-white;\n  }\n\n  .text-body-muted {\n    @apply text-slate-500 dark:text-slate-400;\n  }\n\n  /* --- 2. BUTTONS --- */\n  .btn-pill-outline {\n    @apply flex justify-center items-center w-52 py-3.5 px-7 mx-auto lg:mx-0 border border-slate-300 dark:border-slate-700 shadow-sm rounded-full text-slate-900 dark:text-white font-semibold hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-300 cursor-pointer;\n  }\n\n  .btn-swiper {\n    @apply flex justify-center items-center w-11 h-11 rounded-full border border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white transition-all duration-500 cursor-pointer;\n  }\n\n  .link-action {\n    @apply flex items-center gap-2 text-lg font-semibold text-primary-700 hover:text-primary-900 dark:text-primary-400 dark:hover:text-primary-300 cursor-pointer;\n  }\n\n  /* --- 3. CARDS & LAYOUT --- */\n  .section-bg {\n    @apply bg-slate-50 dark:bg-slate-900 py-24;\n  }\n\n  .card-image-wrapper {\n    @apply flex items-center mb-6 h-64 w-full overflow-hidden rounded-2xl bg-slate-200 dark:bg-slate-800;\n  }\n\n  .card-image {\n    @apply w-full h-full object-cover transition-transform duration-500 group-hover:scale-105;\n  }\n\n  .grid-cols-24 {\n    grid-template-columns: repeat(24, minmax(0, 1fr));\n  }\n\n  /* =========================================\n     TIPTAP EDITOR STYLES (Internal)\n     ========================================= */\n\n  .prose-custom {\n    max-width: none !important;\n    width: 100% !important;\n    @apply text-base text-gray-800 leading-relaxed;\n  }\n\n  .ProseMirror {\n    min-height: 400px;\n    padding-bottom: 50px;\n    outline: none !important;\n  }\n\n  .ProseMirror-focused {\n    outline: none !important;\n  }\n\n  /* Headings & Text */\n  .prose-custom h1 { @apply text-4xl font-extrabold mt-8 mb-4 text-slate-900 leading-tight; }\n  .prose-custom h2 { @apply text-3xl font-bold mt-6 mb-3 text-slate-800 leading-tight; }\n  .prose-custom h3 { @apply text-2xl font-semibold mt-5 mb-2 text-slate-800; }\n  .prose-custom h4 { @apply text-xl font-semibold mt-4 mb-2 text-slate-800; }\n  .prose-custom p { @apply my-3 leading-7; }\n\n  /* Fancy Blockquotes */\n  .prose-custom blockquote {\n    position: relative;\n    border-left: 4px solid #2563eb;\n    background-color: #eff6ff;\n    color: #334155;\n    @apply py-4 pr-4 italic rounded-r-lg shadow-sm pl-14 my-6 block;\n    quotes: none;\n  }\n\n  .dark .prose-custom blockquote {\n    background-color: #1e293b;\n    color: #e2e8e0;\n    border-left-color: #3b82f6;\n  }\n\n  .prose-custom blockquote::before {\n    content: \"“\";\n    position: absolute;\n    top: -0.25rem;\n    left: 0.5rem;\n    font-size: 5rem;\n    line-height: 1;\n    font-family: Georgia, serif;\n    color: #93c5fd;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n\n  /* AI Sections Highlight */\n  .prose-custom section {\n    @apply relative p-6 rounded-xl border border-transparent transition-all;\n  }\n\n  .prose-custom section.ProseMirror-selectednode {\n    @apply border-indigo-400 bg-indigo-50/30;\n  }\n\n  /* Lists & Links */\n  .prose-custom ul { @apply list-disc pl-6 my-3 space-y-1; }\n  .prose-custom ol { @apply list-decimal pl-6 my-3 space-y-1; }\n  .prose-custom pre { @apply bg-slate-900 text-slate-50 p-4 rounded-lg overflow-x-auto my-4 border border-slate-700; }\n  .prose-custom code { @apply bg-slate-100 text-pink-600 px-1.5 py-0.5 rounded text-sm font-mono border border-slate-200; }\n  .prose-custom a { @apply text-blue-600 underline decoration-blue-300 hover:decoration-blue-600 transition-all cursor-pointer; }\n\n  /* --- TABLES --- */\n  .prose-custom table {\n    border-collapse: collapse;\n    margin: 2rem 0;\n    overflow: hidden;\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  .prose-custom td, .prose-custom th {\n    border: 1px solid #cbd5e1 !important;\n    box-sizing: border-box;\n    min-width: 1em;\n    padding: 8px 10px;\n    position: relative;\n    vertical-align: top;\n  }\n\n  .dark .prose-custom td, .dark .prose-custom th { border-color: #475569 !important; }\n\n  .prose-custom th {\n    background-color: #f1f5f9 !important;\n    font-weight: bold;\n    text-align: left;\n  }\n\n  .dark .prose-custom th { background-color: #1e293b !important; color: #fff; }\n\n  /* Table Resize Handles */\n  .column-resize-handle {\n    @apply absolute right-[-2px] bottom-[-2px] top-0 w-1 bg-blue-500 opacity-0 transition-opacity z-20 pointer-events-none;\n  }\n\n  .prose-custom th:hover .column-resize-handle,\n  .prose-custom td:hover .column-resize-handle { @apply opacity-100 pointer-events-auto; }\n\n  .resize-cursor { cursor: col-resize; }\n\n} /* --- END @LAYER COMPONENTS --- */\n\n/* =========================================\n   GLOBAL OVERRIDES (Must be outside layer)\n   ========================================= */\n\n/* 1. THE 2-COLUMN ENGINE (FORCE TRIGGER) */\n/* We target the editor (.ProseMirror) and the preview (.content) */\n[data-layout=\"double\"] .ProseMirror,\n[data-layout=\"double\"] .content,\n[data-layout=\"double\"] #reportBody {\n  display: block !important; /* 🚀 Critical: Columns fail on flex/grid containers */\n  column-count: 2 !important;\n  column-gap: 40px !important;\n  column-fill: auto;\n  text-align: justify;\n  width: 100% !important;\n}\n\n/* 2. BREAKOUT ELEMENTS (Span across both columns) */\n[data-layout=\"double\"] h1,\n[data-layout=\"double\"] .article-header,\n[data-layout=\"double\"] .exec-summary,\n[data-layout=\"double\"] .full-width,\n[data-layout=\"double\"] .cover-page,\n[data-layout=\"double\"] .article-title {\n  column-span: all !important;\n  -webkit-column-span: all !important;\n  width: 100% !important;\n  clear: both;\n  display: block;\n}\n\n/* 3. DYNAMIC LAYOUT ENGINE (UNIVERSAL) */\n/* 🚀 Universal Wrapper for Tables, Charts, Insights, Risk Boxes */\n.ProseMirror .tableWrapper,\n.ProseMirror .layout-wrapper,\n.tableWrapper,\n.layout-wrapper,\n.scientific-chart-wrapper {\n  @apply my-6 transition-all duration-300;\n  width: 100%;\n  clear: both;\n  position: relative; /* Needed for editor badges */\n}\n\n/* --- A. EDITOR VISUALIZATION (Single Column Context) --- */\n/* When editing, we simulate \"Column Fit\" with a visual shrink & badge */\n.ProseMirror .layout-wrapper[data-layout=\"half\"],\n.ProseMirror .tableWrapper[data-layout=\"half\"],\n.ProseMirror .scientific-chart-wrapper[data-layout=\"half\"] {\n  width: 60% !important; /* Visually shrink to indicate it won't be full width */\n  margin-left: auto !important; /* Push right */\n  @apply border-2 border-dashed border-slate-200 bg-slate-50 bg-opacity-50 p-2 rounded-lg;\n}\n\n.ProseMirror .layout-wrapper[data-layout=\"half\"]::after,\n.ProseMirror .tableWrapper[data-layout=\"half\"]::after,\n.ProseMirror .scientific-chart-wrapper[data-layout=\"half\"]::after {\n    content: \"FIT COLUMN\";\n    @apply absolute -top-2.5 right-2 bg-slate-200 text-slate-500 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider select-none;\n}\n\n/* --- B. PDF / PREVIEW LAYOUT (2-Column Context) --- */\n\n/* FULL WIDTH: Breaks out to span both columns */\n[data-layout=\"double\"] .tableWrapper:has(table[data-layout=\"full\"]),\n[data-layout=\"double\"] .tableWrapper:not(:has(table[data-layout])),\n[data-layout=\"double\"] .layout-wrapper[data-layout=\"full\"],\n[data-layout=\"double\"] .scientific-chart-wrapper[data-layout=\"full\"] {\n  column-span: all !important;\n  -webkit-column-span: all !important;\n  width: 100% !important;\n}\n\n/* HALF WIDTH: Captured inside a single column */\n[data-layout=\"double\"] .tableWrapper:has(table[data-layout=\"half\"]),\n[data-layout=\"double\"] .layout-wrapper[data-layout=\"half\"],\n[data-layout=\"double\"] .scientific-chart-wrapper[data-layout=\"half\"] {\n  column-span: none !important;\n  -webkit-column-span: none !important;\n  width: 100% !important; \n  float: none !important;\n  margin-left: 0;\n  @apply border-2 border-indigo-50 bg-indigo-50/10 rounded-lg p-1;\n}\n\n/* --- C. PDF / PREVIEW LAYOUT (1-Column Context) --- */\n/* SINGLE COLUMN DOC FALLBACK: 50% Float Right */\n[data-layout=\"single\"] .tableWrapper:has(table[data-layout=\"half\"]),\n[data-layout=\"single\"] .layout-wrapper[data-layout=\"half\"],\n[data-layout=\"single\"] .scientific-chart-wrapper[data-layout=\"half\"] {\n  width: 50% !important;\n  float: right;\n  @apply ml-6 mb-4;\n}\n\n/* 4. TIPTAP WYSIWYG FIXES */\n.ProseMirror td p, .ProseMirror th p { margin: 0 !important; }\n\n/* Insight/Risk boxes inside layout-wrappers need flex */\n.ProseMirror .layout-wrapper .insight-box, \n.ProseMirror .layout-wrapper .risk-box {\n  display: flex; gap: 12px; padding: 16px; border-radius: 4px; margin: 0;\n}\n\n.ProseMirror .insight-box { background: #f0f9ff; border-left: 4px solid #0ea5e9; }\n.ProseMirror .risk-box { background: #fef2f2; border-left: 4px solid #ef4444; }\n\n/* 5. SCIENTIFIC CHART FIXES */\n.ProseMirror div[data-type=\"scientific-chart\"] {\n  display: block !important;\n  min-height: 400px;\n  width: 100% !important;\n}\n\n.scientific-chart-node {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n}\n\n/* --- CHART LAYOUT LOGIC (FIXED) --- */\n\n/* 1. Base Wrapper */\n.scientific-chart-wrapper {\n  margin: 2rem 0;\n  width: 100%;\n  break-inside: avoid;\n}\n\n/* 2. FULL WIDTH (Breaks out across 2 cols) */\n[data-layout=\"double\"] .scientific-chart-wrapper[data-layout=\"full\"],\n[data-layout=\"double\"] .scientific-chart-wrapper:not([data-layout]) {\n  column-span: all !important;\n  -webkit-column-span: all !important;\n  width: 100% !important;\n}\n\n/* 3. HALF WIDTH (Trapped in column) */\n[data-layout=\"double\"] .scientific-chart-wrapper[data-layout=\"half\"] {\n  column-span: none !important;\n  -webkit-column-span: none !important;\n  width: 100% !important; /* Takes full width of the *column* */\n  float: none !important;\n}\n\n/* 4. EDITOR VISUALIZATION (Single Column Context) */\n/* This makes it visually shrink in the editor so you know it's \"Fit Column\" */\n.ProseMirror .scientific-chart-wrapper[data-layout=\"half\"] {\n  width: 60% !important;\n  margin-left: auto !important;\n  @apply border-2 border-dashed border-slate-200 bg-slate-50 bg-opacity-50 p-2 rounded-lg;\n  position: relative;\n}\n\n.ProseMirror .scientific-chart-wrapper[data-layout=\"half\"]::after {\n    content: \"FIT COLUMN\";\n    @apply absolute -top-2.5 right-2 bg-slate-200 text-slate-500 text-[9px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider select-none;\n}\n\n\n/* Page Guides for TipTap Editor */\n.show-page-guides .ProseMirror {\n  /* 1056px is roughly 11 inches at 96 DPI */\n  background-image: linear-gradient(\n    to bottom, \n    transparent 1055px, \n    #cbd5e1 1055px, \n    #cbd5e1 1056px\n  );\n  background-size: 100% 1056px;\n  min-height: 1056px; /* Ensure at least one page is visible */\n}\n\n/* Double layout */\n.layout-double {\n  column-count: 2;\n  column-gap: 3rem;\n  column-rule: 1px solid #e2e8f0; /* Optional line between columns */\n}\n\n.layout-double h1, \n.layout-double h2, \n.layout-double figure {\n  break-inside: avoid;\n  /* Make big headers span across both columns! */\n  column-span: all; \n}\n\n/* Custom Image Shapes */\n.clip-path-slant {\n  clip-path: polygon(0 0, 100% 0, 100% 85%, 0 100%);\n}\n\n/* =========================================\n   CANVAS TIPTAP EDITOR (Slide Text Boxes)\n   ========================================= */\n/*  Prevent global ProseMirror rules from adding 400px of padding! */\n.tiptap-canvas-editor .ProseMirror {\n  min-height: auto !important;\n  padding-bottom: 0 !important;\n}\n\n/* THE BASELINE SHIFT FIX: \n   Forces Tiptap color spans to lock perfectly to the paragraph's baseline \n   without altering the line-height or vertical flow. \n*/\n.tiptap-canvas-editor .ProseMirror span {\n  vertical-align: baseline !important;\n  line-height: inherit !important;\n  display: inline !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.tiptap-canvas-editor p {\n  margin: 0;\n  line-height: 1.2;\n}\n\n.tiptap-canvas-editor p.is-editor-empty:first-child::before {\n  color: #adb5bd;\n  content: attr(data-placeholder);\n  float: left;\n  height: 0;\n  pointer-events: none;\n}\n.tiptap-canvas-editor ul {\n  list-style-type: disc;\n  padding-left: 1.25em;\n  margin: 0;\n}\n.tiptap-canvas-editor ol {\n  list-style-type: decimal;\n  padding-left: 1.25em;\n  margin: 0;\n}\n.tiptap-canvas-editor strong {\n  font-weight: 900; \n}\n\n\n/* --- PRESENTATION ANIMATIONS --- */\n.animate-fade-in { animation: fadeIn 0.8s ease-out both; }\n.animate-slide-up { animation: slideUp 0.8s ease-out both; }\n.animate-slide-left { animation: slideLeft 0.8s ease-out both; }\n.animate-zoom-in { animation: zoomIn 0.8s ease-out both; }\n.animate-pop { animation: pop 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) both; }\n\n@keyframes fadeIn { \n  from { opacity: 0; } \n  to { opacity: var(--target-opacity, 1); } \n}\n@keyframes slideUp { \n  from { opacity: 0; transform: translateY(40px); } \n  to { opacity: var(--target-opacity, 1); transform: translateY(0); } \n}\n@keyframes slideLeft { \n  from { opacity: 0; transform: translateX(40px); } \n  to { opacity: var(--target-opacity, 1); transform: translateX(0); } \n}\n@keyframes zoomIn { \n  from { opacity: 0; transform: scale(0.8); } \n  to { opacity: var(--target-opacity, 1); transform: scale(1); } \n}\n@keyframes pop { \n  0% { opacity: 0; transform: scale(0.5); } \n  80% { transform: scale(1.05); } \n  100% { opacity: var(--target-opacity, 1); transform: scale(1); } \n}\n\n.delay-0 { animation-delay: 0ms; }\n.delay-500 { animation-delay: 500ms; }\n.delay-1000 { animation-delay: 1000ms; }\n.delay-1500 { animation-delay: 1500ms; }\n.delay-2000 { animation-delay: 2000ms; }\n.delay-2500 { animation-delay: 2500ms; }\n.delay-3000 { animation-delay: 3000ms; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
